import { $ as e, $a as t, $c as ee, $i as te, $n as ne, $o as re, $r as ie, $s as n, $t as r, A as i, Aa as a, Ac as o, Ai as s, An as c, Ao as l, Ar as u, As as d, At as f, B as p, Ba as m, Bc as h, Bi as g, Bn as _, Bo as v, Br as y, Bs as b, Bt as x, C as S, Ca as C, Cc as w, Ci as T, Cn as E, Co as D, Cr as O, Cs as k, Ct as A, D as j, Da as M, Dc as N, Di as P, Dn as F, Do as I, Dr as L, Ds as R, Dt as z, E as B, Ea as V, Ec as H, Ei as U, En as W, Eo as G, Er as K, Es as q, Et as J, F as Y, Fa as ae, Fc as oe, Fi as se, Fn as ce, Fo as le, Fr as ue, Fs as de, Ft as fe, G as pe, Ga as me, Gc as he, Gi as ge, Gn as _e, Go as ve, Gr as ye, Gs as be, Gt as xe, H as Se, Ha as Ce, Hc as we, Hi as Te, Hn as Ee, Ho as De, Hr as Oe, Hs as ke, Ht as Ae, I as je, Ia as Me, Ic as Ne, Ii as Pe, In as Fe, Io as Ie, Ir as Le, Is as Re, It as ze, J as Be, Ja as Ve, Jc as He, Ji as Ue, Jn as We, Jo as Ge, Jr as Ke, Js as qe, Jt as Je, K as Ye, Ka as Xe, Kc as Ze, Ki as Qe, Kn as $e, Ko as et, Kr as tt, Ks as nt, Kt as rt, L as it, La as at, Lc as ot, Li as st, Ln as ct, Lo as lt, Lr as ut, Ls as dt, Lt as ft, M as pt, Ma as mt, Mc as ht, Mi as gt, Mn as _t, Mo as vt, Mr as yt, Ms as bt, Mt as xt, N as St, Na as Ct, Nc as wt, Ni as Tt, Nn as Et, No as Dt, Nr as Ot, Ns as kt, Nt as At, O as jt, Oa as Mt, Oc as Nt, Oi as Pt, On as Ft, Oo as It, Or as Lt, Os as Rt, Ot as zt, P as Bt, Pa as Vt, Pc as Ht, Pi as Ut, Pn as Wt, Po as Gt, Pr as Kt, Ps as qt, Pt as Jt, Q as Yt, Qa as Xt, Qc as Zt, Qi as Qt, Qn as $t, Qo as en, Qr as tn, Qs as nn, Qt as rn, R as an, Ra as on, Rc as sn, Ri as cn, Rn as ln, Ro as un, Rr as dn, Rs as fn, Rt as pn, S as mn, Sa as hn, Sc as gn, Si as _n, Sn as vn, So as yn, Sr as bn, Ss as xn, St as Sn, T as Cn, Ta as wn, Tc as Tn, Ti as En, Tn as Dn, To as On, Tr as kn, Ts as An, Tt as jn, U as Mn, Ua as Nn, Uc as Pn, Ui as Fn, Un as In, Uo as Ln, Ur as Rn, Us as zn, Ut as Bn, V as Vn, Va as Hn, Vc as Un, Vi as Wn, Vn as Gn, Vo as Kn, Vr as qn, Vs as Jn, Vt as Yn, W as Xn, Wa as Zn, Wc as Qn, Wi as $n, Wn as er, Wo as tr, Wr as nr, Ws as rr, Wt as ir, X as ar, Xa as or, Xc as sr, Xi as cr, Xn as lr, Xo as ur, Xr as dr, Xs as fr, Xt as pr, Y as mr, Ya as hr, Yc as gr, Yi as _r, Yn as vr, Yo as yr, Yr as br, Ys as xr, Yt as Sr, Z as Cr, Za as wr, Zc as Tr, Zi as Er, Zn as Dr, Zo as Or, Zr as kr, Zs as Ar, Zt as jr, _ as Mr, _a as Nr, _c as Pr, _i as Fr, _n as Ir, _o as Lr, _r as Rr, _s as zr, _t as Br, a as Vr, aa as Hr, ac as Ur, ai as Wr, al as Gr, an as Kr, ao as qr, ar as Jr, as as Yr, at as Xr, b as Zr, ba as Qr, bc as $r, bi as ei, bn as ti, bo as ni, br as ri, bs as ii, bt as ai, c as oi, ca as si, cc as ci, ci as li, cl as ui, cn as di, co as fi, cr as pi, cs as mi, ct as hi, d as gi, da as _i, dc as vi, di as yi, dn as bi, do as xi, dr as Si, ds as Ci, dt as wi, ea as Ti, ec as Ei, ei as Di, el as Oi, en as ki, eo as Ai, er as ji, es as Mi, et as Ni, f as Pi, fa as Fi, fc as Ii, fi as Li, fn as Ri, fo as zi, fr as Bi, fs as Vi, ft as Hi, g as Ui, ga as Wi, gc as Gi, gi as Ki, gn as qi, go as Ji, gr as Yi, gs as Xi, gt as Zi, h as Qi, ha as $i, hc as ea, hi as ta, hn as na, ho as ra, hr as ia, hs as aa, ht as oa, i as sa, ia as ca, ic as la, ii as ua, il as da, in as fa, io as pa, ir as ma, is as ha, it as ga, j as _a, ja as va, jc as ya, ji as ba, jn as xa, jo as Sa, jr as Ca, js as wa, jt as Ta, k as Ea, ka as Da, kc as Oa, ki as ka, kn as Aa, ko as ja, kr as Ma, ks as Na, kt as Pa, l as Fa, la as Ia, lc as La, li as Ra, ll as za, ln as Ba, lo as Va, lr as Ha, ls as Ua, lt as Wa, m as Ga, ma as Ka, mc as qa, mi as Ja, mn as Ya, mo as Xa, mr as Za, ms as Qa, mt as $a, n as eo, na as to, nc as no, ni as ro, nl as io, nn as ao, no as oo, nr as so, ns as co, nt as lo, o as uo, oa as fo, oc as po, oi as mo, ol as ho, on as go, oo as _o, or as vo, os as yo, ot as bo, p as xo, pa as So, pc as Co, pi as wo, pn as To, po as Eo, pr as Do, ps as Oo, pt as ko, q as Ao, qa as jo, qc as Mo, qi as No, qn as Po, qo as Fo, qr as Io, qs as Lo, qt as Ro, r as zo, ra as Bo, rc as Vo, ri as Ho, rl as Uo, rn as Wo, ro as Go, rr as Ko, rs as qo, rt as Jo, s as Yo, sa as Xo, sc as Zo, si as Qo, sl as $o, sn as es, so as ts, sr as ns, ss as rs, st as is, t as as, ta as os, tc as ss, ti as cs, tl as ls, tn as us, to as ds, tr as fs, ts as ps, tt as ms, u as hs, ua as gs, uc as _s, ui as vs, ul as ys, un as bs, uo as xs, ur as Ss, us as Cs, ut as ws, v as Ts, va as Es, vc as Ds, vi as Os, vn as ks, vo as As, vr as js, vs as Ms, vt as Ns, w as Ps, wa as Fs, wc as Is, wi as Ls, wn as Rs, wo as zs, wr as Bs, ws as Vs, wt as Hs, x as Us, xa as Ws, xc as Gs, xi as Ks, xn as qs, xo as Js, xr as Ys, xs as Xs, xt as Zs, y as Qs, ya as $s, yc as ec, yi as tc, yn as nc, yo as rc, yr as ic, ys as ac, yt as oc, z as sc, za as cc, zc as lc, zi as uc, zn as dc, zo as fc, zr as pc, zs as mc, zt as hc } from "./apiUrls-C_lSY48S.js";
import { $ as gc, A as _c, B as vc, C as yc, D as bc, E as xc, F as Sc, G as Cc, H as wc, I as Tc, J as Ec, K as Dc, L as X, M as Oc, N as kc, O as Z, P as Ac, Q as jc, R as Mc, S as Nc, T as Pc, U as Fc, V as Ic, W as Lc, X as Rc, Y as zc, Z as Bc, _ as Vc, a as Hc, b as Uc, c as Wc, d as Gc, et as Kc, f as qc, g as Jc, h as Yc, i as Xc, j as Zc, k as Qc, l as $c, m as el, n as tl, o as nl, p as rl, q as il, r as al, s as ol, t as sl, tt as cl, u as ll, v as ul, w as dl, x as fl, y as pl, z as ml } from "./types-DS2q1O7f.js";
import { n as hl, r as gl, t as _l } from "./useShipmentPricingService-CDLT9QIX.js";
import { DeliveryTypeName as Q, Weight as vl } from "@myparcel-frontend/types";
import { units as yl } from "@myparcel-frontend/utils";
//#region src/generated/schemas.gen.ts
var bl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, xl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "User Error",
	type: "object",
	required: [
		"message",
		"request_id",
		"status_code",
		"errors"
	],
	additionalProperties: !1,
	properties: {
		message: { type: "string" },
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		errors: {
			type: ["array", "object"],
			items: { $ref: "#/components/schemas/common_error_user" },
			additionalProperties: { $ref: "#/components/schemas/common_error_user" }
		}
	}
}, Sl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 4xx (Client Error)",
	description: "The request contains bad syntax or cannot be fulfilled",
	type: "integer",
	minimum: 400,
	maximum: 499
}, Cl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, wl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [{ $ref: "#/components/schemas/common_error_user_code_auth" }, { type: "integer" }]
}, Tl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.error.user.code.Auth",
	description: "Authentication and Authorization related error codes",
	type: "integer",
	enum: [
		3e3,
		3001,
		3002,
		3003,
		3004,
		3005,
		3006,
		3007
	],
	oneOf: [
		{
			enum: [3e3],
			title: "AccessDenied",
			description: "Access Denied"
		},
		{
			enum: [3001],
			title: "PermissionDenied",
			description: "Permission Denied"
		},
		{
			enum: [3002],
			title: "SessionTokenNotFound",
			description: "Session Token Not Found"
		},
		{
			enum: [3003],
			title: "LastLoginAttemptFailed",
			description: "Last login attempt failed"
		},
		{
			enum: [3004],
			title: "MaxLoginAttemptsReached",
			description: "Max login attempts reached"
		},
		{
			enum: [3005],
			title: "SessionTokenInvalidated",
			description: "Session Token Invalidated"
		},
		{
			enum: [3006],
			title: "InvalidJwtToken",
			description: "Invalid JWT Token"
		},
		{
			enum: [3007],
			title: "UserNotFoundInAuthcontext",
			description: "User Not Found in Auth Context"
		}
	],
	"x-enum-varnames": [
		"AccessDenied",
		"PermissionDenied",
		"SessionTokenNotFound",
		"LastLoginAttemptFailed",
		"MaxLoginAttemptsReached",
		"SessionTokenInvalidated",
		"InvalidJwtToken",
		"UserNotFoundInAuthcontext"
	],
	"x-enum-descriptions": [
		"Access Denied",
		"Permission Denied",
		"Session Token Not Found",
		"Last login attempt failed",
		"Max login attempts reached",
		"Session Token Invalidated",
		"Invalid JWT Token",
		"User Not Found in Auth Context"
	]
}, El = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [404],
	title: "Not Found",
	description: "Did not find the requested target resource."
}, Dl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			description: "A list of Shipment Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_shipment" }
		} }
	} }
}, Ol = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment resource",
	required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.secondary_shipments.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
	properties: {
		id: {
			type: "integer",
			format: "int64",
			title: "Shipment ID",
			description: "Unique ID of a Shipment."
		},
		parent_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		account_id: { $ref: "#/components/schemas/account_defs_account_properties_id" },
		shop_id: { $ref: "#/components/schemas/account_defs_shop_properties_id" },
		shipment_type: { $ref: "#/components/schemas/_ref_shipment_type" },
		recipient: {
			allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
			required: ["cc", "person"]
		},
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		status: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
		options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
		general_settings: { $ref: "#/components/schemas/_ref_shipment_general_settings" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		customs_declaration: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }] },
		physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_physical_properties" },
		reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" },
		transaction_status: { $ref: "#/components/schemas/_ref_shipment_transaction_status" },
		drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_drop_off_point" },
		hidden: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		barcode: {
			type: "string",
			maxLength: 255
		},
		region: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }]
		},
		external_provider: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }] },
		external_provider_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }] },
		payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_payment_status" },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		platform_id: { $ref: "#/components/schemas/account_defs_platform_properties_id" },
		origin: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }] },
		user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent" },
		secondary_shipments: {
			type: "array",
			items: {
				title: "Secondary Shipment resource",
				required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					parent_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_parent_id" },
					account_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_account_id" },
					shop_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shop_id" },
					shipment_type: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipment_type" },
					recipient: { $ref: "#/components/schemas/shipment_defs_shipment_properties_recipient" },
					sender: { $ref: "#/components/schemas/shipment_defs_shipment_properties_sender" },
					status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_status" },
					options: { $ref: "#/components/schemas/shipment_defs_shipment_properties_options" },
					general_settings: { $ref: "#/components/schemas/shipment_defs_shipment_properties_general_settings" },
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup" },
					customs_declaration: { $ref: "#/components/schemas/shipment_defs_shipment_properties_customs_declaration" },
					physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_properties_physical_properties" },
					reference_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_reference_identifier" },
					transaction_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_transaction_status" },
					drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_properties_drop_off_point" },
					hidden: { $ref: "#/components/schemas/shipment_defs_shipment_properties_hidden" },
					price: { $ref: "#/components/schemas/shipment_defs_shipment_properties_price" },
					barcode: { $ref: "#/components/schemas/shipment_defs_shipment_properties_barcode" },
					region: { $ref: "#/components/schemas/shipment_defs_shipment_properties_region" },
					external_provider: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider" },
					external_provider_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider_id" },
					payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_payment_status" },
					carrier_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_carrier_id" },
					platform_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_platform_id" },
					origin: { $ref: "#/components/schemas/shipment_defs_shipment_properties_origin" },
					user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_properties_user_agent" },
					secondary_shipments: {
						type: ["null", "array"],
						maxItems: 0
					},
					collection_contact: { $ref: "#/components/schemas/shipment_defs_shipment_properties_collection_contact" },
					multi_collo_main_shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_multi_collo_main_shipment_id" },
					external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_identifier" },
					delayed: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delayed" },
					delivered: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delivered" },
					amount: { $ref: "#/components/schemas/shipment_defs_shipment_properties_amount" },
					currency: { $ref: "#/components/schemas/shipment_defs_shipment_properties_currency" },
					contract_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_contract_id" },
					link_consumer_portal: { $ref: "#/components/schemas/shipment_defs_shipment_properties_link_consumer_portal" },
					partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_properties_partner_tracktraces" },
					pickup_request_number: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup_request_number" },
					order_shipment_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_order_shipment_identifier" },
					shipped_items: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipped_items" },
					created: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created" },
					modified: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified" },
					created_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created_by" },
					modified_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified_by" }
				},
				additionalProperties: !1
			}
		},
		collection_contact: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }] },
		multi_collo_main_shipment_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier" },
		delayed: {
			type: "boolean",
			default: !1
		},
		delivered: {
			type: "boolean",
			default: !1
		},
		amount: {
			type: ["integer", "null"],
			format: "int32"
		},
		currency: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }] },
		contract_id: {
			type: ["integer", "null"],
			format: "int64"
		},
		link_consumer_portal: {
			type: ["null", "string"],
			oneOf: [{ format: "uri" }, { enum: [""] }]
		},
		partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces" },
		pickup_request_number: { type: ["null", "string"] },
		order_shipment_identifier: {
			type: ["null", "string"],
			format: "uuid",
			maxLength: 36
		},
		shipped_items: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" }
		},
		created: { $ref: "#/components/schemas/common_defs_timestamps_properties_created" },
		modified: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified" },
		created_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_created_by" },
		modified_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified_by" }
	},
	additionalProperties: !1
}, kl = {
	type: "integer",
	format: "int64",
	title: "Shipment ID",
	description: "Unique ID of a Shipment.",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Al = {
	title: "Account ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, jl = {
	title: "Shop ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ml = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.Type",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8
	],
	oneOf: [
		{
			enum: [1],
			title: "Standard"
		},
		{
			enum: [2],
			title: "Return"
		},
		{
			enum: [3],
			title: "MultiCollo"
		},
		{
			enum: [4],
			title: "LabelPackage"
		},
		{
			enum: [5],
			title: "ReturnErs"
		},
		{
			enum: [6],
			title: "ReturnSpecial"
		},
		{
			enum: [7],
			title: "Express"
		},
		{
			enum: [8],
			title: "Fulfilment"
		}
	],
	"x-enum-varnames": [
		"Standard",
		"Return",
		"MultiCollo",
		"LabelPackage",
		"ReturnErs",
		"ReturnSpecial",
		"Express",
		"Fulfilment"
	]
}, Nl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Recipient",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_sender" }],
	properties: {
		person: { maxLength: 50 },
		first_name: {
			type: "string",
			maxLength: 50
		},
		last_name: {
			type: "string",
			maxLength: 50
		},
		company: { maxLength: 50 },
		street: {
			maxLength: 40,
			minLength: 1,
			pattern: "\\D+"
		},
		street_additional_info: { maxLength: 50 },
		number: { maxLength: 8 },
		number_suffix: { maxLength: 6 },
		postal_code: { maxLength: 10 },
		city: {
			maxLength: 35,
			minLength: 1
		},
		state: { maxLength: 2 },
		area: { maxLength: 35 },
		phone: { maxLength: 25 }
	}
}, Pl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Sender",
	type: "object",
	required: ["cc"],
	additionalProperties: !1,
	properties: {
		account_id: { $ref: "#/components/schemas/account_defs_account_properties_id" },
		person: { type: "string" },
		first_name: { type: "string" },
		last_name: { type: "string" },
		company: { type: ["null", "string"] },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: ["null", "string"] },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		state: { type: "string" },
		cc: { $ref: "#/components/schemas/_ref_types_cc" },
		region: {
			type: ["null", "string"],
			maxLength: 35
		},
		area: { type: "string" },
		phone: { type: ["null", "string"] },
		email: {
			type: ["null", "string"],
			anyOf: [{ format: "email" }, { enum: [null, ""] }]
		},
		billing_email: { $ref: "#/components/schemas/account_defs_contact_properties_email" },
		secondary_emails: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_sender_properties_email" }
		},
		box_number: {
			type: ["null", "string"],
			maxLength: 8
		},
		eori_number: { type: "string" },
		vat_number: { type: "string" },
		invalid: { type: "boolean" }
	}
}, Fl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, Il = {
	type: ["null", "string"],
	maxLength: 255,
	anyOf: [{ enum: [null, ""] }, { format: "email" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ll = {
	type: ["null", "string"],
	anyOf: [{ format: "email" }, { enum: [null, ""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Rl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.shipment.Status",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		98,
		99,
		100,
		101,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38
	],
	oneOf: [
		{
			enum: [1],
			title: "PendingConcept",
			description: "Pending - Concept\n\nThe Shipment is a concept and not yet registered at the carrier.\n"
		},
		{
			enum: [2],
			title: "PendingRegistered",
			description: "Pending - Registered\n\nThe Shipment has been registered with the carrier, and has been assigned a Track & Trace code.\n"
		},
		{
			enum: [3],
			title: "EnrouteHandedToCarrier",
			description: "En Route - Handed to Carrier\n\nThe Shipment has been handed to the carrier for transport.\n"
		},
		{
			enum: [4],
			title: "EnrouteSorting",
			description: "En Route - Sorting\n\nThe Shipment is being sorted at the carrier's sorting facility.\n"
		},
		{
			enum: [5],
			title: "EnrouteDistribution",
			description: "En Route - Distribution\n\nThe Shipment is being distributed by the carrier to the recipient's address.\n"
		},
		{
			enum: [6],
			title: "DeliveredAtCustoms",
			description: "En Route - Customs\n\nThe Shipment is being processed by customs.\n"
		},
		{
			enum: [7],
			title: "Delivered",
			description: "Delivered - At Recipient\n\nThe Shipment has been delivered to the recipient.\n"
		},
		{
			enum: [8],
			title: "InPickupLocation",
			description: "Delivered - Ready for Pickup\n\nThe Shipment is ready for pickup at a pickup location.\n"
		},
		{
			enum: [9],
			title: "PickedUp",
			description: "Delivered - Picked Up\n\nThe Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [10],
			title: "ReturnShipmentDelivered",
			description: "Delivered - Return Shipment Ready for Pickup\n\nThe Return Shipment is ready to be picked at a pickup location.\n"
		},
		{
			enum: [11],
			title: "ReturnShipmentInPickupLocation",
			description: "Delivered - Return Shipment Picked Up\n\nThe Return Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [12],
			title: "PrintedUnpaidLabel",
			description: "Printed - Unpaid Label\n\nThe label has been printed without postage paid.\n"
		},
		{
			enum: [13],
			title: "Credit",
			description: "Credited\n\nThe Shipment has been credited.\n"
		},
		{
			enum: [14],
			title: "PrintedStamp",
			description: "Printed - Digital Stamp\n\nThe Shipment has been printed with a digital stamp.\n"
		},
		{
			enum: [15],
			title: "PrintedExternalShipment",
			description: "Printed - External Shipment\n\nThe Shipment has been printed with an External Shipment.\n"
		},
		{
			enum: [16],
			title: "Expired",
			description: "Expired\n\nThe Shipment has expired.\n"
		},
		{
			enum: [17],
			title: "Cancelled",
			description: "Cancelled\n\nThe Shipment has been cancelled.\n"
		},
		{
			enum: [18],
			title: "PrintedUntrackedShipment",
			description: "Printed - Untracked Shipment\n\nThe Shipment has been printed with an untracked Shipment.\n"
		},
		{
			enum: [19],
			title: "DeliveredAtAgreedLocation",
			description: "Delivered - At Agreed Location\n\nThe Shipment has been delivered at a privately agreed location.\n"
		},
		{
			enum: [98],
			title: "Inactive",
			description: "Inactive\n\nThe Shipment is inactive.\n"
		},
		{
			enum: [99],
			title: "Deleted",
			description: "Deleted\n\nThe Shipment has been deleted.\n"
		},
		{
			enum: [100],
			title: "CreditRejected",
			description: "Credit - Rejected\n\nThe credit request for the Shipment was rejected.\n"
		},
		{
			enum: [101],
			title: "CreditApproved",
			description: "Credit - Approved\n\nThe credit request for the Shipment was approved.\n"
		},
		{
			enum: [30],
			title: "LegacyPendingConcept",
			description: "(legacy) Pending - Concept"
		},
		{
			enum: [31],
			title: "LegacyPendingRegistered",
			description: "(legacy) Pending - Registered"
		},
		{
			enum: [32],
			title: "LegacyEnrouteHandedToCarrier",
			description: "(legacy) En Route - Handed to Carrier"
		},
		{
			enum: [33],
			title: "LegacyEnrouteSorting",
			description: "(legacy) En Route - Sorting"
		},
		{
			enum: [34],
			title: "LegacyEnrouteDistribution",
			description: "(legacy) En Route - Distribution"
		},
		{
			enum: [35],
			title: "LegacyDeliveredAtCustoms",
			description: "(legacy) En Route - Customs"
		},
		{
			enum: [36],
			title: "LegacyDelivered",
			description: "(legacy) Delivered - At Recipient"
		},
		{
			enum: [37],
			title: "LegacyInPickupLocation",
			description: "(legacy) Delivered - Ready for Pickup"
		},
		{
			enum: [38],
			title: "LegacyPickedUp",
			description: "(legacy) Delivered - Picked Up"
		}
	],
	"x-enum-varnames": /* @__PURE__ */ "PendingConcept.PendingRegistered.EnrouteHandedToCarrier.EnrouteSorting.EnrouteDistribution.DeliveredAtCustoms.Delivered.InPickupLocation.PickedUp.ReturnShipmentDelivered.ReturnShipmentInPickupLocation.PrintedUnpaidLabel.Credit.PrintedStamp.PrintedExternalShipment.Expired.Cancelled.PrintedUntrackedShipment.DeliveredAtAgreedLocation.Inactive.Deleted.CreditRejected.CreditApproved.LegacyPendingConcept.LegacyPendingRegistered.LegacyEnrouteHandedToCarrier.LegacyEnrouteSorting.LegacyEnrouteDistribution.LegacyDeliveredAtCustoms.LegacyDelivered.LegacyInPickupLocation.LegacyPickedUp".split("."),
	"x-enum-descriptions": [
		"The Shipment is a concept and not yet registered at the carrier.",
		"The Shipment has been registered with the carrier, and has been assigned a Track & Trace code.",
		"The Shipment has been handed to the carrier for transport.",
		"The Shipment is being sorted at the carrier's sorting facility.",
		"The Shipment is being distributed by the carrier to the recipient's address",
		"The Shipment is being processed by customs.",
		"The Shipment has been delivered to the recipient.",
		"The Shipment is ready for pickup at a pickup location.",
		"The Shipment has been picked up by the recipient at a pickup location.",
		"The Return Shipment is ready to be picked at a pickup location.",
		"The Return Shipment has been picked up by the recipient at a pickup location.",
		"The label has been printed without postage paid.",
		"The Shipment has been credited.",
		"The Shipment label has been printed as a digital stamp.",
		"A Shipment label has been printed for an External Shipment.",
		"The Shipment has expired.",
		"The Shipment has been canceled.",
		"The Shipment has been printed with an untracked Shipment.",
		"The Shipment has been delivered at a privately agreed location - e.g. in front of the door, under a bush, etc.",
		"The Shipment is inactive.",
		"The Shipment has been deleted.",
		"The credit request for the Shipment was rejected."
	]
}, zl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [
		{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
		{ $ref: "#/components/schemas/_ref_shipment_options_options" },
		{ $ref: "#/components/schemas/_ref_shipment_options_package_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_delivery_date" },
		{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
	]
}, Bl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_options_insurance" }],
	properties: { insurance: { properties: { amount: { maximum: 25e5 } } } }
}, Vl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { insurance: {
		$comment: "insurance currency must be EUR because shipment carriers expect this",
		$ref: "#/components/schemas/_ref_types_price_euro"
	} }
}, Hl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price with EUR-currency and amount",
	type: "object",
	additionalProperties: !1,
	required: ["amount", "currency"],
	properties: {
		currency: {
			type: "string",
			enum: ["EUR"]
		},
		amount: {
			minimum: 0,
			type: "integer"
		}
	}
}, Ul = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_types_money" },
		collect: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		fresh_food: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		frozen: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		no_tracking: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		priority_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		tracked: {
			description: "DEPRECATED: replaced by no_tracking (its inverse).",
			$ref: "#/components/schemas/_ref_types_int_boolean"
		}
	}
}, Wl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.IntBoolean",
	type: "number",
	enum: [0, 1],
	"x-enum-varnames": ["False", "True"]
}, Gl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Money",
	description: "Money amount with currency",
	type: "object",
	required: ["currency", "amount"],
	additionalProperties: !1,
	properties: {
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		},
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			oneOf: [{
				type: "integer",
				minimum: 0
			}, {
				type: ["string"],
				pattern: "\\d*"
			}]
		}
	}
}, Kl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" } }
}, ql = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageType",
	description: "Package Type.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: [2],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: [3],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: [4],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: [5],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: [6],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: [7],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, Jl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_type: {
		type: ["integer", "null"],
		enum: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			null
		]
	} }
}, Yl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_date: {
		type: ["string", "null"],
		pattern: "([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})"
	} }
}, Xl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { label_description: {
		type: ["null", "string"],
		maxLength: 45
	} }
}, Zl = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification_email: {
			type: "array",
			items: {
				type: "string",
				format: "email"
			}
		},
		disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		printer_identifier: { type: "string" },
		tracktrace: {
			type: "object",
			properties: {
				bcc: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				bcc_email: { $ref: "#/components/schemas/account_defs_contact_properties_email" },
				carrier_email_basic_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification_email: {
					type: "array",
					items: { type: "string" }
				},
				disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				email_on_handed_to_courier: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				from_address_company: { type: "string" },
				from_address_email: {
					type: "string",
					anyOf: [{ format: "email" }, { enum: [""] }]
				},
				printer_identifier: { type: "string" },
				save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				send_track_trace_emails: { $ref: "#/components/schemas/_ref_types_int_boolean" }
			}
		}
	},
	additionalProperties: !1
}, Ql = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Pickup Location",
	type: ["null", "object"],
	additionalProperties: !1,
	properties: {
		location_code: { type: "string" },
		location_name: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		location_type: { oneOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { $ref: "#/components/schemas/_ref_shipment_bpost_bpost_pugo_type" }] },
		retail_network_id: { type: "string" }
	}
}, $l = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Pickup / drop-off location type.",
	type: "string",
	enum: [
		"retail",
		"locker",
		"post_office"
	],
	oneOf: [
		{
			enum: ["retail"],
			title: "Retail",
			description: "Shops/postal points."
		},
		{
			enum: ["locker"],
			title: "Locker",
			description: "Automated parcel locker."
		},
		{
			enum: ["post_office"],
			title: "PostOffice",
			description: "Post office location."
		}
	],
	"x-enum-varnames": [
		"Retail",
		"Locker",
		"PostOffice"
	]
}, eu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.bpost.BpostPugoType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		4,
		8,
		16
	],
	oneOf: [
		{
			enum: [0],
			title: "Unknown"
		},
		{
			enum: [1],
			title: "PostOffice"
		},
		{
			enum: [2],
			title: "PostPoint"
		},
		{
			enum: [4],
			title: "ParcelLocker"
		},
		{
			enum: [8],
			title: "ClickCollect"
		},
		{
			enum: [16],
			title: "ParcelPoint"
		}
	],
	"x-enum-varnames": [
		"Unknown",
		"PostOffice",
		"PostPoint",
		"ParcelLocker",
		"ClickCollect",
		"ParcelPoint"
	]
}, tu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.CustomsDeclaration",
	type: ["object"],
	required: [
		"contents",
		"weight",
		"items"
	],
	properties: {
		contents: { $ref: "#/components/schemas/shipment_defs_customs_shipment_type" },
		invoice: {
			type: ["string", "null"],
			maxLength: 150
		},
		eori_number: { type: ["string", "null"] },
		vat_number: { type: ["string", "null"] },
		vat_number_uk: { type: ["string", "null"] },
		voec_number: { type: ["string", "null"] },
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		items: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: { $ref: "#/components/schemas/_ref_shipment_customs_declaration_item" }
		}
	},
	additionalProperties: !1
}, nu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CustomsShipmentType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5
	],
	oneOf: [
		{
			enum: [1],
			title: "CommercialGoods"
		},
		{
			enum: [2],
			title: "CommercialSample"
		},
		{
			enum: [3],
			title: "Documents"
		},
		{
			enum: [4],
			title: "Gift"
		},
		{
			enum: [5],
			title: "ReturnedGoods"
		}
	],
	"x-enum-varnames": [
		"CommercialGoods",
		"CommercialSample",
		"Documents",
		"Gift",
		"ReturnedGoods"
	]
}, ru = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"description",
		"amount",
		"weight",
		"item_value",
		"classification"
	],
	properties: {
		description: {
			type: "string",
			maxLength: 50
		},
		amount: {
			type: "integer",
			minimum: 1,
			maximum: 99999
		},
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		item_value: { $ref: "#/components/schemas/_ref_types_money" },
		classification: { type: "string" },
		country: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: [""] }]
		}
	},
	additionalProperties: !1
}, iu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Physical Properties",
	type: ["null", "object"],
	properties: {
		weight: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight" },
		height: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height" }, { type: "null" }] },
		width: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width" }, { type: "null" }] },
		length: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length" }, { type: "null" }] },
		volume: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume" }, { type: "null" }] },
		carrier_weight: { anyOf: [
			{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_weight" },
			{
				type: "string",
				pattern: "^\\d+$"
			},
			{ type: "null" }
		] },
		carrier_height: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_height" }, { type: "null" }] },
		carrier_width: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_width" }, { type: "null" }] },
		carrier_length: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_length" }, { type: "null" }] },
		carrier_volume: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_volume" }, { type: "null" }] }
	},
	additionalProperties: !1
}, au = {
	type: "integer",
	format: "int32",
	minimum: 0,
	maximum: 999999999,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ou = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, su = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, cu = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, lu = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, uu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight"
}, du = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, fu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, pu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, mu = {
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume" }, { type: "null" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, hu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Reference Identifier",
	description: "Arbitrary reference identifier that can be used to identify a shipment.",
	type: [
		"null",
		"integer",
		"string"
	],
	maxLength: 255,
	pattern: "^[^=\\?]*$"
}, gu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, _u = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Drop-Off Point",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_pickup" }],
	required: [
		"location_code",
		"location_name",
		"street",
		"number",
		"postal_code",
		"city"
	]
}, vu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "MoneyNullableAmount",
	description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS).",
	type: "object",
	required: ["currency", "amount"],
	additionalProperties: !1,
	properties: {
		currency: { $ref: "#/components/schemas/_ref_types_money_properties_currency" },
		amount: {
			description: "The amount in the lowest denomination of the currency (e.g. cents for EUR), or null when the requester may not read price amounts.",
			oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_types_money_properties_amount" }]
		}
	}
}, yu = {
	description: "The currency as uppercase 3-letter ISO 4217 code.",
	type: "string",
	enum: ["", "EUR"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, bu = {
	description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
	oneOf: [{
		type: "integer",
		minimum: 0
	}, {
		type: ["string"],
		pattern: "\\d*"
	}],
	$schema: "http://json-schema.org/draft-04/schema#"
}, xu = {
	title: "External Provider Display Name",
	type: "string",
	enum: [
		"Facebook",
		"Google",
		"Flespakket.nl",
		"Amazon",
		"Bol.com",
		"MyParcel.nl",
		"Wix",
		"Ecwid",
		"Exact Online DE",
		"Exact Online NL",
		"Etsy"
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Su = {
	title: "External Provider ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Cu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Payment Status",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, wu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.Carrier",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: [5]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: [6]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: [7]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: [8]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: [20]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim"
	]
}, Tu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_id"
}, Eu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformId",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [1],
			title: "myparcel"
		},
		{
			enum: [2],
			title: "flespakket"
		},
		{
			enum: [3],
			title: "belgie"
		},
		{
			enum: [4],
			title: "delivery_dutch"
		},
		{
			enum: [5],
			title: "postnl_customer"
		},
		{
			enum: [6],
			title: "italy"
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, Du = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ou = {
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ku = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Au = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_account_properties_id"
}, ju = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_shop_properties_id"
}, Mu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_type"
}, Nu = {
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
	required: ["cc", "person"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Pu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_sender"
}, Fu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_status"
}, Iu = {
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Lu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_general_settings"
}, Ru = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_pickup"
}, zu = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Bu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_physical_properties"
}, Vu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_reference_identifier"
}, Hu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_transaction_status"
}, Uu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_drop_off_point"
}, Wu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_int_boolean"
}, Gu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_money_nullable_amount"
}, Ku = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, qu = {
	type: "string",
	oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ju = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Yu = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Xu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_payment_status"
}, Zu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_carrier"
}, Qu = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_properties_id"
}, $u = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, ed = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent"
}, td = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, nd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Contact",
	type: "object",
	required: [
		"last_name",
		"email",
		"phone",
		"company",
		"street",
		"number",
		"postal_code",
		"city",
		"cc"
	],
	additionalProperties: !1,
	properties: {
		id: {
			type: ["integer"],
			format: "int32"
		},
		gender: {
			type: ["null", "string"],
			maxLength: 3
		},
		first_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		last_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		email: {
			type: ["null", "string"],
			maxLength: 255,
			anyOf: [{ enum: [null, ""] }, { format: "email" }]
		},
		phone: {
			type: ["null", "string"],
			maxLength: 100
		},
		company: {
			type: ["null", "string"],
			maxLength: 255
		},
		street: { $ref: "#/components/schemas/account_defs_location_properties_street" },
		street_additional_info: { $ref: "#/components/schemas/account_defs_location_properties_street_additional_info" },
		number: { $ref: "#/components/schemas/account_defs_location_properties_number" },
		number_suffix: { $ref: "#/components/schemas/account_defs_location_properties_number_suffix" },
		postal_code: { $ref: "#/components/schemas/account_defs_location_properties_postal_code" },
		city: { $ref: "#/components/schemas/account_defs_location_properties_city" },
		cc: { $ref: "#/components/schemas/account_defs_location_properties_cc" },
		region: { $ref: "#/components/schemas/account_defs_location_properties_region" },
		box_number: { $ref: "#/components/schemas/account_defs_location_properties_box_number" }
	}
}, rd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, id = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ad = {
	type: ["string", "integer"],
	pattern: "\\d+",
	$schema: "http://json-schema.org/draft-04/schema#"
}, od = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, sd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, cd = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ld = {
	type: "string",
	pattern: "^[A-Z][A-Z]$",
	$schema: "http://json-schema.org/draft-04/schema#"
}, ud = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, dd = {
	type: ["null", "string"],
	maxLength: 8,
	$schema: "http://json-schema.org/draft-04/schema#"
}, fd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, pd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier"
}, md = {
	title: "Shipment Carrier External Identifier",
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, hd = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, gd = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, _d = {
	type: ["integer", "null"],
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, vd = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, yd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Currency",
	type: "string",
	maxLength: 3,
	enum: ["", "EUR"]
}, bd = {
	type: ["integer", "null"],
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, xd = {
	type: ["null", "string"],
	oneOf: [{ format: "uri" }, { enum: [""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Sd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces"
}, Cd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Partner Track & Traces",
	type: "array",
	items: {
		type: "object",
		required: ["uri", "barcode"],
		properties: {
			uri: {
				type: "string",
				anyOf: [{ enum: [""] }, { format: "uri" }]
			},
			barcode: { type: "string" }
		}
	}
}, wd = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Td = {
	type: ["null", "string"],
	format: "uuid",
	maxLength: 36,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ed = {
	type: ["null", "array"],
	items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Dd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipped Item",
	type: ["null", "object"],
	properties: {
		quantity: { $ref: "#/components/schemas/order_defs_shipped_item_properties_quantity" },
		order_line_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line_identifier" },
		order_line: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line" },
		picklist_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_picklist_identifier" },
		order_identifier: { type: ["null", "string"] }
	},
	additionalProperties: !1
}, Od = {
	type: ["null", "integer"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, kd = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ad = {
	type: ["null", "object"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, jd = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Md = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created"
}, Nd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, Pd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateAndTime",
	description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1]) ([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, Fd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified"
}, Id = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, Ld = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created_by"
}, Rd = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, zd = {
	title: "User ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Bd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified_by"
}, Vd = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Hd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	format: "binary",
	anyOf: [{ contentMediaType: "application/pdf" }, { contentMediaType: "application/vnd.zpl" }]
}, Ud = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [
			{
				required: ["pdf"],
				additionalProperties: !1,
				properties: { pdf: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["pdfs"],
				additionalProperties: !1,
				properties: { pdfs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["csvs"],
				additionalProperties: !1,
				properties: { csvs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["zpl"],
				additionalProperties: !1,
				properties: { zpl: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				required: ["zpls"],
				additionalProperties: !1,
				properties: { zpls: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			}
		]
	} },
	definitions: { url: {
		type: "object",
		required: ["url"],
		additionalProperties: !1,
		properties: { url: {
			type: "string",
			format: "uri"
		} }
	} }
}, Wd = {
	type: "object",
	required: ["url"],
	additionalProperties: !1,
	properties: { url: {
		type: "string",
		format: "uri"
	} },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Gd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "object",
			required: ["unpaid_shipments", "blocked_shipments"],
			additionalProperties: !1,
			properties: {
				unpaid_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" },
				blocked_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" }
			}
		} }
	} }
}, Kd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	items: {
		type: "object",
		required: [
			"shipment_id",
			"price",
			"price_after_vat"
		],
		additionalProperties: !1,
		properties: {
			shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			price: { $ref: "#/components/schemas/_ref_types_money" },
			price_after_vat: { $ref: "#/components/schemas/_ref_types_money" }
		}
	}
}, qd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Instructions",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["payment_instructions"],
		properties: { payment_instructions: {
			type: "array",
			items: { $ref: "#/components/schemas/billing_defs_payment_data" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Jd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Data",
	type: "object",
	required: [
		"id",
		"hash",
		"type",
		"notification_hash",
		"original_notification_hash",
		"paid",
		"price",
		"payment_url",
		"invoices"
	],
	properties: {
		id: { type: "string" },
		hash: { type: "string" },
		type: { type: "integer" },
		notification_hash: { type: "string" },
		original_notification_hash: { type: "string" },
		paid: {
			type: "integer",
			enum: [0, 1]
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		payment_url: {
			type: ["string", "null"],
			format: "uri"
		},
		invoices: {
			type: "object",
			required: [
				"id",
				"number",
				"status"
			],
			properties: {
				id: { type: "integer" },
				number: { type: "string" },
				status: { type: "integer" }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, Yd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price",
	description: "Price amount in a specific currency",
	type: "object",
	required: ["amount", "currency"],
	properties: {
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			type: ["integer", "null"]
		},
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		}
	},
	additionalProperties: !1
}, Xd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Bad Request",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, Zd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [400],
	title: "Bad Request",
	description: "The server will not process the request due to a client error."
}, Qd = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Problem Details (RFC 9457)",
	description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n",
	type: "object",
	required: [
		"type",
		"title",
		"status",
		"detail"
	],
	properties: {
		type: {
			type: "string",
			description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n"
		},
		title: {
			type: "string",
			description: "A short, human-readable summary of the problem type."
		},
		status: {
			type: "integer",
			description: "The HTTP status code for this occurrence."
		},
		detail: {
			type: "string",
			description: "A human-readable explanation specific to this occurrence."
		},
		instance: {
			type: "string",
			description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n"
		},
		request_id: {
			type: "string",
			description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n"
		},
		errors: {
			type: "array",
			description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n",
			items: {
				type: "object",
				required: [
					"type",
					"title",
					"detail"
				],
				properties: {
					type: { type: "string" },
					title: { type: "string" },
					detail: { type: "string" },
					instance: { type: "string" }
				}
			}
		}
	}
}, $d = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV2",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["deliveries"],
		properties: { deliveries: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v2" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, ef = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_option.DeliveryOptionV2",
	type: "object",
	required: ["date", "possibilities"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_time" },
		possibilities: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_possibility" }
		}
	},
	additionalProperties: !1
}, tf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateTime",
	type: "object",
	required: [
		"date",
		"timezone",
		"timezone_type"
	],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_and_time" },
		timezone: { type: "string" },
		timezone_type: { $ref: "#/components/schemas/common_defs_time_zone_type" }
	}
}, nf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.TimeZoneType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3
	],
	oneOf: [
		{
			enum: [0],
			title: "None"
		},
		{
			enum: [1],
			title: "Offset",
			description: "A UTC offset, such as `+01:00`\n"
		},
		{
			enum: [2],
			title: "Abbreviation",
			description: "A timezone abbreviation, such as `CET`\n"
		},
		{
			enum: [3],
			title: "Identifier",
			description: "A timezone identifier, such as `Europe/Amsterdam`\n"
		}
	],
	"x-enum-varnames": [
		"None",
		"Offset",
		"Abbreviation",
		"Identifier"
	],
	"x-enum-descriptions": [
		"None",
		"A UTC offset, such as `+01:00`",
		"A timezone abbreviation, such as `CET`",
		"A timezone identifier, such as `Europe/Amsterdam`"
	]
}, rf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryPossibility",
	type: "object",
	required: [
		"type",
		"package_type",
		"delivery_time_frames",
		"shipment_options"
	],
	properties: {
		type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_name-v2" }, { type: "null" }] },
		package_type: { $ref: "#/components/schemas/shipment_responses_delivery_options_package_type-v2" },
		delivery_time_frames: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_time_frame" }
		},
		shipment_options: {
			type: "array",
			items: {
				type: "object",
				required: ["name", "schema"],
				properties: {
					name: { type: "string" },
					schema: {
						type: "object",
						required: ["type", "enum"],
						properties: {
							type: { enum: ["boolean"] },
							enum: {
								type: "array",
								items: { type: "boolean" }
							}
						},
						additionalProperties: !1
					}
				},
				additionalProperties: !1
			}
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, af = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryNameV2",
	type: "string",
	enum: [
		"morning",
		"standard",
		"evening",
		"same_day",
		"express",
		"early_morning"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["morning"]
		},
		{
			title: "Standard",
			enum: ["standard"]
		},
		{
			title: "Evening",
			enum: ["evening"]
		},
		{
			title: "SameDay",
			enum: ["same_day"]
		},
		{
			title: "Express",
			enum: ["express"]
		},
		{
			title: "EarlyMorning",
			enum: ["early_morning"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, of = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.delivery_options.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"package",
		"mailbox",
		"unfranked",
		"digital_stamp",
		"pallet",
		"small_package",
		"envelope"
	],
	oneOf: [
		{
			enum: ["package"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["mailbox"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["unfranked"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["digital_stamp"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["pallet"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["small_package"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["envelope"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, sf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTimeFrame",
	type: "object",
	required: ["type", "date_time"],
	properties: {
		type: { enum: ["start", "end"] },
		date_time: { $ref: "#/components/schemas/common_defs_date_time" }
	},
	additionalProperties: !1
}, cf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV1",
	type: "object",
	required: ["data"],
	properties: {
		data: {
			type: "object",
			required: ["delivery", "pickup"],
			properties: {
				delivery: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v1" }
				},
				pickup: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup" }
				},
				message: { type: "string" }
			},
			additionalProperties: !1
		},
		errors: {
			type: "array",
			items: { anyOf: [{ $ref: "#/components/schemas/error" }, {
				type: "object",
				required: ["code", "message"],
				properties: {
					code: { type: "integer" },
					message: { type: "string" },
					human: { type: "string" }
				},
				additionalProperties: !1
			}] }
		}
	},
	additionalProperties: !1
}, lf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryOptionV1",
	type: "object",
	required: ["date", "time"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date" },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_time" }
		}
	},
	additionalProperties: !1
}, uf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Date",
	description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n",
	type: "string",
	format: "date",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1])"
}, df = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTime",
	type: "object",
	required: [
		"start",
		"end",
		"price",
		"price_comment",
		"comment",
		"type"
	],
	properties: {
		start: { $ref: "#/components/schemas/common_defs_time" },
		end: { $ref: "#/components/schemas/common_defs_time" },
		price: { $ref: "#/components/schemas/common_defs_price" },
		price_comment: { type: "string" },
		comment: { type: "string" },
		type: { type: "integer" },
		collect_date: { $ref: "#/components/schemas/common_defs_date_time" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, ff = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Time",
	description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	format: "time",
	pattern: "([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, pf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.Pickup",
	type: "object",
	properties: {
		date: { anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }] },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup_time" }
		},
		location: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: { type: "string" },
		start_time: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		price: { type: "integer" },
		price_comment: {
			type: "string",
			enum: ["retail", "retailexpress"]
		},
		comment: { type: "string" },
		phone_number: { type: "string" },
		opening_hours: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours" },
		distance: { type: "string" },
		latitude: { $ref: "#/components/schemas/common_defs_latitude" },
		longitude: { $ref: "#/components/schemas/common_defs_longitude" },
		location_code: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		holiday: {
			type: "object",
			properties: {
				from: { type: ["string", "null"] },
				to: { type: ["string", "null"] }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, mf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.PickupTime",
	type: "object",
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		price: { $ref: "#/components/schemas/common_defs_price" }
	}
}, hf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		6,
		7,
		8
	],
	oneOf: [
		{
			title: "Morning",
			enum: [1]
		},
		{
			title: "Standard",
			enum: [2]
		},
		{
			title: "Evening",
			enum: [3]
		},
		{
			title: "Pickup",
			enum: [4]
		},
		{
			title: "SameDay",
			enum: [6]
		},
		{
			title: "Express",
			enum: [7]
		},
		{
			title: "EarlyMorning",
			enum: [8]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, gf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.OpeningHours",
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		tuesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		wednesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		thursday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		friday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		saturday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		sunday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" }
	},
	additionalProperties: !1,
	definitions: { opening_hours: {
		description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
		type: "array",
		items: { type: "string" }
	} }
}, _f = {
	description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
	type: "array",
	items: { type: "string" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, vf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Latitude",
	type: ["number", "string"],
	minimum: -90,
	maximum: 90,
	pattern: "^[-+]?(90|[0-8]?\\d)(\\.\\d+)?$"
}, yf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Longitude",
	type: ["number", "string"],
	minimum: -180,
	maximum: 180,
	pattern: "^[-+]?(180|(0?\\d{0,2}|1[0-7]\\d)(\\.\\d+)?)$"
}, bf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["code", "message"],
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, xf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code: Error",
	type: "integer",
	anyOf: [{ $ref: "#/components/schemas/common_http_status_code_4xx_client_error" }, { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" }]
}, Sf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 5xx (Server Error)",
	description: "The server failed to fulfill an apparently valid request",
	type: "integer",
	minimum: 500,
	maximum: 599
}, Cf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, wf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [406],
	title: "Not Acceptable",
	description: "The target resource doesn't have an acceptable representation for the user agent."
}, Tf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["download_url"],
		properties: { download_url: { $ref: "#/components/schemas/common_defs_download_url" } },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Ef = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "DownloadUrl",
	description: "DownloadUrl Object Definition",
	required: ["link"],
	properties: { link: {
		type: "string",
		format: "uri"
	} },
	additionalProperties: !1
}, Df = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoints",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["drop_off_points"],
		properties: { drop_off_points: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point" }
		} },
		additionalProperties: !1
	} }
}, Of = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoint",
	type: "object",
	properties: {
		location_code: { type: "string" },
		location_name: { type: ["string", "null"] },
		cc: { type: "string" },
		state: { type: ["string", "null"] },
		city: { type: "string" },
		postal_code: { type: "string" },
		street: { type: "string" },
		number: { type: [
			"string",
			"integer",
			"null"
		] },
		number_suffix: { type: ["string", "null"] },
		phone: { type: ["string", "null"] },
		reference: { type: ["string", "null"] },
		longitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }] },
		latitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }] },
		available_days: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_available_days" },
		cut_off_time: { type: ["string", "null"] },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		distance: { type: ["number", "null"] },
		occupancy: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_occupancy" }, { type: "null" }] },
		occupancy_today: { type: ["number", "null"] },
		default_drop_off_point: { type: ["boolean", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_opening_hours" }
	},
	definitions: {
		available_days: {
			type: ["array", "null"],
			items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] }
		},
		opening_hours: {
			type: ["object", "null"],
			properties: {
				monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
			},
			additionalProperties: !1
		},
		timeframes: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" }
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, kf = {
	type: ["array", "null"],
	items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Af = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.DayOfWeek",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [0],
			title: "Sunday"
		},
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		}
	],
	"x-enum-varnames": [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	]
}, jf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.IsoDayOfWeek",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		},
		{
			enum: [7],
			title: "Sunday"
		}
	],
	"x-enum-varnames": [
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
		"Sunday"
	]
}, Mf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.Occupancy",
	type: "object",
	properties: {
		monday: { type: ["number", "null"] },
		tuesday: { type: ["number", "null"] },
		wednesday: { type: ["number", "null"] },
		thursday: { type: ["number", "null"] },
		friday: { type: ["number", "null"] },
		saturday: { type: ["number", "null"] },
		sunday: { type: ["number", "null"] }
	}
}, Nf = {
	type: ["object", "null"],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Pf = {
	type: "array",
	items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ff = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, If = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
					code: { enum: [3100] }
				}
			}
		}
	} }]
}, Lf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [415],
	title: "Unsupported Media Type",
	description: "Content is in a format not supported by this method on the target resource."
}, Rf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, zf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [401],
	title: "Unauthorized",
	description: "The request lacks valid authentication credentials for the target resource."
}, Bf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.PickupLocations",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["pickup_locations"],
		properties: { pickup_locations: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_pickup_location" }
		} },
		additionalProperties: !1
	} },
	definitions: {
		pickup_location: {
			type: "object",
			required: [
				"address",
				"possibilities",
				"location"
			],
			properties: {
				address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
				possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
				location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
			},
			additionalProperties: !1
		},
		address: {
			type: "object",
			required: [
				"cc",
				"city",
				"street",
				"postal_code",
				"number"
			],
			properties: {
				cc: { type: "string" },
				city: { type: "string" },
				street: { type: "string" },
				postal_code: { type: "string" },
				number: { type: "string" },
				number_suffix: { type: ["string", "null"] }
			},
			additionalProperties: !1
		},
		possibilities: {
			type: "array",
			items: {
				type: "object",
				required: [
					"delivery_type_id",
					"delivery_type_name",
					"price",
					"moment"
				],
				properties: {
					delivery_type_id: { type: "integer" },
					delivery_type_name: { type: "string" },
					price: { type: "integer" },
					moment: {
						type: "object",
						properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
					}
				},
				additionalProperties: !1
			}
		},
		location: {
			type: "object",
			required: [
				"location_name",
				"retail_network_id",
				"distance",
				"latitude",
				"longitude",
				"location_code",
				"phone_number",
				"type",
				"opening_hours"
			],
			properties: {
				location_name: { type: "string" },
				retail_network_id: { type: ["string", "null"] },
				distance: { type: "string" },
				latitude: { type: "string" },
				longitude: { type: "string" },
				location_code: { type: "string" },
				phone_number: { type: ["string", "null"] },
				type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
				opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
			},
			additionalProperties: !1
		},
		opening_hours: {
			type: "object",
			required: [
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
				"sunday"
			],
			properties: {
				monday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				tuesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				wednesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				thursday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				friday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				saturday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				sunday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				}
			},
			additionalProperties: !1
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, Vf = {
	type: "object",
	required: [
		"address",
		"possibilities",
		"location"
	],
	properties: {
		address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
		possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
		location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Hf = {
	type: "object",
	required: [
		"cc",
		"city",
		"street",
		"postal_code",
		"number"
	],
	properties: {
		cc: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		postal_code: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Uf = {
	type: "array",
	items: {
		type: "object",
		required: [
			"delivery_type_id",
			"delivery_type_name",
			"price",
			"moment"
		],
		properties: {
			delivery_type_id: { type: "integer" },
			delivery_type_name: { type: "string" },
			price: { type: "integer" },
			moment: {
				type: "object",
				properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
			}
		},
		additionalProperties: !1
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, Wf = {
	type: "object",
	required: [
		"location_name",
		"retail_network_id",
		"distance",
		"latitude",
		"longitude",
		"location_code",
		"phone_number",
		"type",
		"opening_hours"
	],
	properties: {
		location_name: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		distance: { type: "string" },
		latitude: { type: "string" },
		longitude: { type: "string" },
		location_code: { type: "string" },
		phone_number: { type: ["string", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Gf = {
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		tuesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		wednesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		thursday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		friday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		saturday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		sunday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		}
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Kf = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, qf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			pdf: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/pdfs/.*"
				} }
			},
			zpl: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/zpls/.*"
				} }
			}
		}
	} }
}, Jf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of Shipment IDs.",
			items: {
				type: "object",
				required: ["id", "reference_identifier"],
				additionalProperties: !1,
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
				}
			}
		} }
	} }
}, Yf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [{
			required: ["ids", "pdf"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				pdf: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/pdfs/.*"
					} }
				}
			}
		}, {
			required: ["ids", "zpl"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				zpl: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/zpls/.*"
					} }
				}
			}
		}]
	} }
}, Xf = {
	type: "array",
	description: "A list of Shipment IDs.",
	items: {
		type: "object",
		required: ["id", "reference_identifier"],
		additionalProperties: !1,
		properties: {
			id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
		}
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, Zf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "System Error",
	type: "object",
	properties: {
		message: {
			type: "string",
			description: "A human-readable description of the error."
		},
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		errors: {
			type: "array",
			items: { $ref: "#/components/schemas/common_error_system" }
		}
	}
}, Qf = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		code: { type: "integer" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, $f = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["shipments", "results"],
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			results: {
				type: "integer",
				description: "The number of results."
			}
		},
		additionalProperties: !1
	} },
	additionalProperties: !1
}, ep = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.TrackTraces",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["tracktraces"],
		properties: { tracktraces: {
			type: "array",
			description: "A list of Track & Trace Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_track_trace" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, tp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTrace",
	description: "A Track & Trace resource.",
	type: "object",
	required: [
		"shipment_id",
		"carrier",
		"code",
		"description",
		"time",
		"link_consumer_portal",
		"link_tracktrace",
		"partner_tracktraces",
		"recipient",
		"sender",
		"options",
		"pickup",
		"delayed",
		"location",
		"status",
		"history"
	],
	properties: {
		shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
		carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
		code: { type: "string" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		link_consumer_portal: {
			type: ["string", "null"],
			format: "uri"
		},
		link_tracktrace: {
			type: ["string", "null"],
			format: "uri"
		},
		partner_tracktraces: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_external_track_trace_link" }
		},
		recipient: { $ref: "#/components/schemas/shipment_defs_shipment_recipient" },
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" },
		status: {
			type: "object",
			required: [
				"current",
				"main",
				"final"
			],
			properties: {
				current: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
				main: { $ref: "#/components/schemas/shipment_defs_main_status" },
				final: { type: "boolean" }
			},
			additionalProperties: !1
		},
		history: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_history" },
		delivery_moment_type: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_type" },
		delivery_moment: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_time_frame" },
		signature: { $ref: "#/components/schemas/shipment_defs_track_trace_proof_of_delivery" },
		returnable: { type: "boolean" }
	},
	additionalProperties: !1
}, np = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.ExternalTrackTraceLink",
	type: "object",
	required: ["uri", "barcode"],
	properties: {
		uri: {
			type: "string",
			format: "uri"
		},
		barcode: { type: "string" }
	},
	additionalProperties: !1
}, rp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackingLocation",
	required: [
		"name",
		"cc",
		"city",
		"postal_code",
		"street",
		"number",
		"number_suffix",
		"longitude",
		"latitude"
	],
	properties: {
		name: { type: ["string"] },
		cc: { type: ["string", "null"] },
		city: { type: ["string", "null"] },
		postal_code: { type: ["string", "null"] },
		street: { type: ["string", "null"] },
		number: { type: ["string", "null"] },
		number_suffix: { type: ["string", "null"] },
		longitude: { type: ["number", "null"] },
		latitude: { type: ["number", "null"] }
	},
	additionalProperties: !1
}, ip = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.MainStatus",
	type: ["string", "null"],
	enum: [
		"registered",
		"handed_to_carrier",
		"sorting",
		"distribution",
		"delivered",
		null
	]
}, ap = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceHistory",
	type: "array",
	items: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_event" }
}, op = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceEvent",
	type: "object",
	required: [
		"code",
		"status",
		"main",
		"description",
		"time",
		"delayed",
		"location"
	],
	properties: {
		code: { type: "string" },
		status: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_status" }] },
		main: { $ref: "#/components/schemas/shipment_defs_main_status" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" }
	},
	additionalProperties: !1
}, sp = {
	type: ["string", "null"],
	enum: [
		"estimated",
		"expected",
		null
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, cp = {
	type: ["object", "null"],
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, lp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTraceProofOfDelivery",
	anyOf: [
		{ type: "null" },
		{
			type: "string",
			format: "base64"
		},
		{
			type: "object",
			required: ["content", "content_type"],
			properties: {
				content: { type: "string" },
				content_type: { type: "string" }
			},
			additionalProperties: !1
		}
	]
}, up = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		description: "A list of V2 Capabilities for a given Shipment configuration.",
		items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v2" }
	} },
	additionalProperties: !1
}, dp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"physicalProperties",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v2" },
		physicalProperties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties-v2" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, fp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.CarrierV2",
	description: "Carrier string definition for capabilities endpoints (v2)",
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTE_ITALIANE",
		"POSTNL",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	],
	oneOf: [
		{
			description: "bpost",
			title: "Bpost",
			enum: ["BPOST"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["BRT"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["CHEAP_CARGO"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["DHL_EUROPLUS"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["DHL_FOR_YOU"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["DHL_PARCEL_CONNECT"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["DPD"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["GLS"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["INPOST"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["POSTE_ITALIANE"]
		},
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["POSTNL"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["SPRING"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["TRUNKRS"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["UPS_EXPRESS_SAVER"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["UPS_STANDARD"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["VIA_TIM"]
		}
	],
	"x-enum-varnames": [
		"Bpost",
		"Brt",
		"CheapCargo",
		"DhlEuroplus",
		"DhlForYou",
		"DhlParcelConnect",
		"Dpd",
		"Gls",
		"Inpost",
		"PosteItaliane",
		"Postnl",
		"Spring",
		"Trunkrs",
		"UpsExpressSaver",
		"UpsStandard",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"bpost",
		"BRT",
		"Cheap Cargo",
		"DHL Europlus",
		"DHL For You",
		"DHL Parcel Connect",
		"DPD",
		"GLS",
		"InPost",
		"PosteItaliane",
		"PostNL",
		"Spring",
		"Trunkrs",
		"UPS Express Saver",
		"UPS Standard",
		"Via Tim"
	]
}, pp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v2)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	}
}, mp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"PACKAGE",
		"MAILBOX",
		"UNFRANKED",
		"DIGITAL_STAMP",
		"PALLET",
		"SMALL_PACKAGE",
		"ENVELOPE"
	],
	oneOf: [
		{
			enum: ["PACKAGE"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["MAILBOX"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["UNFRANKED"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["DIGITAL_STAMP"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["PALLET"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["SMALL_PACKAGE"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["ENVELOPE"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, hp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			freshFood: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }
		}
	}]
}, gp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		freshFood: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		hideSender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		noTracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }
	}
}, _p = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["isSelectedByDefault", "isRequired"],
	properties: {
		isSelectedByDefault: { type: "boolean" },
		isRequired: { type: "boolean" }
	}
}, vp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are excluded"
			}
		}
	}]
}, yp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, bp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		default: { $ref: "#/components/schemas/_ref_types_money" },
		min: { $ref: "#/components/schemas/_ref_types_money" },
		max: { $ref: "#/components/schemas/_ref_types_money" }
	}
}, xp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		width: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		height: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		girth: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volumetricWeight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volume: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		lengthWidthHeightSum: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" }
	}
}, Sp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"min",
		"max",
		"calculation"
	],
	additionalProperties: !1,
	properties: {
		min: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		max: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		calculation: { type: "string" }
	}
}, Cp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["value", "unit"],
	additionalProperties: !1,
	properties: {
		value: {
			type: "number",
			description: "The numeric value"
		},
		unit: {
			type: "string",
			enum: [
				"g",
				"kg",
				"cm",
				"mm",
				"mm3",
				"cm3",
				"dm3",
				"m3"
			],
			description: "The unit of measurement in SI units"
		}
	}
}, wp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryTypeV2",
	type: "string",
	enum: [
		"MORNING_DELIVERY",
		"STANDARD_DELIVERY",
		"EVENING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["MORNING_DELIVERY"]
		},
		{
			title: "Standard",
			enum: ["STANDARD_DELIVERY"]
		},
		{
			title: "Evening",
			enum: ["EVENING_DELIVERY"]
		},
		{
			title: "Pickup",
			enum: ["PICKUP_DELIVERY"]
		},
		{
			title: "SameDay",
			enum: ["SAME_DAY_DELIVERY"]
		},
		{
			title: "Express",
			enum: ["EXPRESS_DELIVERY"]
		},
		{
			title: "EarlyMorning",
			enum: ["EARLY_MORNING_DELIVERY"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Tp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	enum: ["B2B", "B2C"]
}, Ep = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["max"],
	additionalProperties: !1,
	properties: { max: { type: "integer" } }
}, Dp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		properties: { capabilities: {
			type: "array",
			description: "A list of V1 Capabilities for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Op = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"physical_properties",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v1" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v1" },
		physical_properties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties-v1" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, kp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.Carrier",
	description: "Carrier ID definition for capabilities endpoints (v1)",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: [20]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim"
	]
}, Ap = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v1)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	}
}, jp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			fresh_food: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }
		}
	}]
}, Mp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		collect: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		fresh_food: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		hide_sender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		large_format: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		no_tracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		only_recipient: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		printerless_return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		receipt_code: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		signature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }
	}
}, Np = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["is_selected_by_default", "is_required"],
	properties: {
		is_selected_by_default: { type: "boolean" },
		is_required: { type: "boolean" }
	}
}, Pp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are excluded"
			}
		}
	}]
}, Fp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, Ip = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		default: { $ref: "#/components/schemas/_ref_types_money" },
		min: { $ref: "#/components/schemas/_ref_types_money" },
		max: { $ref: "#/components/schemas/_ref_types_money" }
	}
}, Lp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		width: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		height: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		girth: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volumetric_weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volume: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length_width_height_sum: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" }
	}
}, Rp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["items"],
	properties: { items: {
		type: "array",
		description: "A superset of V2 Capabilities for the contracts within a user's account.",
		items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v2" }
	} },
	additionalProperties: !1
}, zp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v2" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, Bp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }
		}
	}]
}, Vp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		additionalProperties: !1
	}]
}, Hp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, Up = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["contract_definitions"],
		properties: { contract_definitions: {
			type: "array",
			description: "A superset of V1 Capabilities for the contracts within a user's account.",
			items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Wp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Capability contract definitions response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v1" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, Gp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }
		}
	}]
}, Kp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		additionalProperties: !1
	}]
}, qp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, Jp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"shipmentType",
		"priceComposition"
	],
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		deliveryType: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" },
		shipmentType: { $ref: "#/components/schemas/_ref_shipment_shipment_type-v2" },
		priceComposition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v2" }
	},
	additionalProperties: !1
}, Yp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, Xp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	enum: [
		"EXPRESS",
		"FULFILMENT",
		"LABEL_PACKAGE",
		"MULTI_COLLO",
		"RETURN",
		"RETURN_ERS",
		"RETURN_SPECIAL",
		"STANDARD"
	]
}, Zp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The V2 price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
	},
	additionalProperties: !1
}, Qp = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"priceWithVat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		priceWithVat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" }
	},
	additionalProperties: !1
}, $p = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["rates"],
		properties: { rates: {
			type: "array",
			description: "A list of V1 Rates for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_rates_response_rate-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, em = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"package_type",
		"shipment_type",
		"price_composition"
	],
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract" },
		package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
		delivery_type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		shipment_type: { $ref: "#/components/schemas/_ref_types_shipment_type" },
		price_composition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v1" }
	},
	additionalProperties: !1
}, tm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, nm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	]
}, rm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
	},
	additionalProperties: !1
}, im = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"price_with_vat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" },
		price_with_vat: { $ref: "#/components/schemas/_ref_types_money_nullable_amount" }
	},
	additionalProperties: !1
}, am = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_group" }
	} },
	additionalProperties: !1
}, om = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Group response item",
	type: "object",
	required: [
		"id",
		"shopId",
		"packageType",
		"countryCode",
		"shipmentDirection",
		"fallback"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		shopId: { type: "integer" },
		packageType: {
			type: ["string", "null"],
			enum: [
				"DIGITAL_STAMP",
				"ENVELOPE",
				"UNFRANKED",
				"MAILBOX",
				"PACKAGE",
				"PALLET",
				"SMALL_PACKAGE",
				null
			]
		},
		countryCode: {
			type: ["string", "null"],
			minLength: 2,
			maxLength: 2,
			pattern: "^[A-Z]{2}$",
			description: "ISO 3166-1 alpha-2 country code"
		},
		shipmentDirection: {
			type: "string",
			enum: ["OUTBOUND", "INBOUND"]
		},
		fallback: { type: "boolean" }
	}
}, sm = {
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_template" }
	} }
}, cm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Template response item",
	type: "object",
	required: [
		"id",
		"notificationGroupId",
		"type",
		"subject",
		"body",
		"active"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		notificationGroupId: { type: "integer" },
		type: { $ref: "#/components/schemas/_ref_notification_notification_template_type" },
		subject: { type: "string" },
		body: { type: "string" },
		active: { type: "boolean" }
	}
}, lm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The notification template type.",
	type: "string",
	enum: [
		"LABEL_DOWNLOAD",
		"FIRST_SCAN",
		"RETURN"
	]
}, um = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, dm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, fm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.0" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, pm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, mm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of created webhook subscription IDs.",
			items: {
				type: "object",
				required: ["id"],
				additionalProperties: !1,
				properties: { id: { type: "integer" } }
			}
		} }
	} }
}, hm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.Barcode",
	type: "string",
	minLength: 6,
	maxLength: 32,
	pattern: "^[a-zA-Z0-9\\-\\s]+$"
}, gm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_carrier_id" }, { $ref: "#/components/schemas/shipment_parameters_carrier_name" }]
}, _m = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierId",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: ["string", "null"],
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"10",
		"11",
		"12",
		"13",
		"14",
		"15",
		"16",
		"17",
		"18",
		"19",
		"20"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["1"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["2"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["3"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["4"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["5"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["6"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["7"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["8"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["9"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["10"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["11"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["12"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["13"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["14"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["15"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["16"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["17"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["18"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["19"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["20"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"Via Tim"
	]
}, vm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierName",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "string",
	enum: [
		"postnl",
		"bpost",
		"cheapcargo",
		"dpd",
		"instabox",
		"dhl",
		"bol.com",
		"ups",
		"dhlforyou",
		"dhlparcelconnect",
		"dhleuroplus",
		"upsstandard",
		"upsexpresssaver",
		"gls",
		"brt",
		"trunkrs",
		"inpost",
		"posteitaliane",
		"spring",
		"viatim"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["postnl"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["bpost"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["cheapcargo"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["dpd"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["instabox"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["dhl"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["bol.com"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["ups"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["dhlforyou"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["dhlparcelconnect"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["dhleuroplus"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["upsstandard"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["upsexpresssaver"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["gls"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["brt"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["trunkrs"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["inpost"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["posteitaliane"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["spring"]
		},
		{
			description: "Via Tim",
			title: "ViaTim",
			enum: ["viatim"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring",
		"ViaTim"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring",
		"ViaTim"
	]
}, ym = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "collect_date",
	type: ["string", "null"],
	format: "date",
	pattern: "\\d{4}-\\d{2}-\\d{2}"
}, bm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.CountryCode",
	description: "ISO 3166-1 alpha-2 country code",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, xm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CutoffTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Sm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Boolean",
	anyOf: [
		{ type: "boolean" },
		{
			type: "integer",
			minimum: 0,
			maximum: 1
		},
		{
			type: "number",
			anyOf: [{
				minimum: 0,
				maximum: 0
			}, {
				minimum: 1,
				maximum: 1
			}]
		},
		{
			type: "string",
			enum: [
				"0",
				"1",
				"false",
				"true"
			]
		}
	]
}, Cm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.FilterValidateBool",
	type: [
		"boolean",
		"integer",
		"string",
		"null"
	],
	enum: [
		!1,
		!0,
		0,
		1,
		"0",
		"1",
		"false",
		"true",
		"off",
		"on",
		"no",
		"yes",
		"",
		null
	]
}, wm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryDate",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }]
}, Tm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Em = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "delivery_options_identifier",
	type: ["string", "null"]
}, Dm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.WeekdayDigit",
	description: "A semi-colon delimited list of weekday digits between 0 and 6 (0 = Sunday).\n",
	type: ["string", "null"],
	pattern: "^([0-6](;[0-6])*)?$"
}, Om = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTypes",
	type: "string",
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_delivery_type" }, { pattern: "^[1-8](;[1-8])*$" }]
}, km = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryType",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"6",
		"7",
		"8"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["1"]
		},
		{
			title: "Standard",
			enum: ["2"]
		},
		{
			title: "Evening",
			enum: ["3"]
		},
		{
			title: "Pickup",
			enum: ["4"]
		},
		{
			title: "SameDay",
			enum: ["6"]
		},
		{
			title: "Express",
			enum: ["7"]
		},
		{
			title: "EarlyMorning",
			enum: ["8"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Am = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "paper_size",
	description: "The size of a paper as specified in ISO216.",
	type: "string",
	enum: ["A4", "A6"]
}, jm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Latitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }]
}, Mm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Longitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }]
}, Nm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "order",
	description: "Specify whether the results should be sorted in ascending or descending order.",
	type: "string",
	enum: ["ASC", "DESC"],
	oneOf: [{
		enum: ["ASC"],
		title: "Ascending",
		description: "Results are ordered from lesser to greater values, e.g. from A to Z."
	}, {
		enum: ["DESC"],
		title: "Descending",
		description: "Results are ordered from greater to lesser values, e.g. from Z to A."
	}]
}, Pm = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "Shipment Package Type",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_package_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		{
			type: "string",
			pattern: "^[1-7](;[1-7]){0,5}$"
		}
	]
}, Fm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "page",
	description: "Request a specific page of the results, used for paginated results.",
	type: "integer",
	minimum: 1,
	maximum: 1e3
}, Im = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/account_defs_platform_name" }, { $ref: "#/components/schemas/account_parameters_platform_id" }]
}, Lm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformName",
	type: "string",
	enum: [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["myparcel"]
		},
		{
			title: "flespakket",
			enum: ["flespakket"]
		},
		{
			title: "belgie",
			enum: ["belgie"]
		},
		{
			title: "delivery_dutch",
			enum: ["delivery_dutch"]
		},
		{
			title: "postnl_customer",
			enum: ["postnl_customer"]
		},
		{
			title: "italy",
			enum: ["italy"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, Rm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformId",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["1"]
		},
		{
			title: "flespakket",
			enum: ["2"]
		},
		{
			title: "belgie",
			enum: ["3"]
		},
		{
			title: "delivery_dutch",
			enum: ["4"]
		},
		{
			title: "postnl_customer",
			enum: ["5"]
		},
		{
			title: "italy",
			enum: ["6"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, zm = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.LabelPosition",
	description: "The position of the label on the paper.",
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_label_printing_position" }, {
		type: "string",
		pattern: "^[0-4](;[1-4]){0,3}$"
	}]
}, Bm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.label.PrintingPosition",
	description: "The position of the label on the paper.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4
	],
	oneOf: [
		{
			enum: [1],
			title: "TopLeftQuadrant",
			description: "Top-Left Quadrant"
		},
		{
			enum: [2],
			title: "TopRightQuadrant",
			description: "Top-Right Quadrant"
		},
		{
			enum: [3],
			title: "BottomLeftQuadrant",
			description: "Bottom-Left Quadrant"
		},
		{
			enum: [4],
			title: "BottomRightQuadrant",
			description: "Bottom-Right Quadrant"
		}
	],
	"x-enum-varnames": [
		"TopLeftQuadrant",
		"TopRightQuadrant",
		"BottomLeftQuadrant",
		"BottomRightQuadrant"
	],
	"x-enum-descriptions": [
		"Top-Left Quadrant",
		"Top-Right Quadrant",
		"Bottom-Left Quadrant",
		"Bottom-Right Quadrant"
	]
}, Vm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.PostalCode",
	type: ["string", "null"],
	minLength: 2,
	maxLength: 12,
	pattern: "^[a-zA-Z0-9\\-\\s]{2,12}$",
	format: "postal-code"
}, Hm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigIds",
	type: ["integer", "string"],
	anyOf: [{ $ref: "#/components/schemas/common_parameters_bigid" }, {
		type: "string",
		pattern: "^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$"
	}]
}, Um = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigId",
	type: "integer",
	format: "int64",
	minimum: 1,
	maximum: 0x8000000000000000
}, Wm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_type" }
		},
		{
			type: "string",
			pattern: "^[1-8](;[1-8]){0,7}$"
		}
	]
}, Gm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ids",
	anyOf: [
		{ $ref: "#/components/schemas/common_parameters_id" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/common_parameters_id" }
		},
		{
			type: "string",
			pattern: "^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$"
		}
	]
}, Km = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "id",
	type: "integer",
	format: "int32",
	minimum: 1,
	maximum: 2147483647
}, qm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "size",
	description: "Specify the number of resources returned per page, used for paginated results.",
	type: "integer",
	minimum: 0,
	maximum: 1e4
}, Jm = {
	$schema: "http://package-json.org/draft-04/schema#",
	type: "string",
	enum: [
		"amount",
		"created",
		"created_by",
		"currency",
		"drop_off_point",
		"hidden",
		"id",
		"mark_delivered",
		"modified",
		"modified_by",
		"order_shipment_identifier",
		"parent_id",
		"recipient",
		"reference_identifier",
		"sender",
		"shipment_type",
		"shop_id",
		"status",
		"transaction_status"
	]
}, Ym = {
	$schema: "http://json-schema.org/draft-04/schema#",
	oneOf: [
		{ $ref: "#/components/schemas/shipment_defs_shipment_status" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_shipment_status" }
		},
		{
			type: "string",
			pattern: "^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$"
		}
	]
}, Xm = {
	$schema: "http://package-json.org/draft-04/schema#",
	title: "extra_info",
	type: "string",
	pattern: "^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\\1(?:;|$)))+;*$"
}, Zm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: [
						"options",
						"carrier",
						"recipient"
					],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						contract_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"postal_code",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								},
								eori_number: { type: ["string", "null"] },
								vat_number: { type: ["string", "null"] }
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						drop_off_point: {
							type: ["object", "null"],
							required: [
								"location_code",
								"postal_code",
								"location_name",
								"city",
								"street",
								"number"
							],
							additionalProperties: !1,
							properties: {
								postal_code: { type: "string" },
								location_name: { type: "string" },
								city: { type: "string" },
								street: { type: "string" },
								number: { type: "string" },
								number_suffix: { type: "string" },
								box_number: { type: "string" },
								region: { type: "string" },
								state: { type: "string" },
								cc: { type: "string" },
								location_code: { type: "string" },
								retail_network_id: { type: "string" }
							}
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						secondary_shipments: {
							type: "array",
							minItems: 1,
							items: {
								type: "object",
								additionalProperties: !1,
								properties: {
									account_id: { type: "integer" },
									shop_id: { type: "integer" },
									reference_identifier: {
										type: ["integer", "string"],
										maxLength: 255,
										pattern: "^[^=\\?]*$"
									},
									recipient: {
										type: "object",
										additionalProperties: !1,
										properties: {
											cc: {
												type: "string",
												minLength: 2,
												maxLength: 2
											},
											region: {
												type: "string",
												maxLength: 35
											},
											state: {
												type: "string",
												maxLength: 2
											},
											postal_code: {
												type: "string",
												maxLength: 10
											},
											city: {
												type: "string",
												maxLength: 35,
												minLength: 1
											},
											street: {
												type: "string",
												maxLength: 40,
												minLength: 1
											},
											street_additional_info: {
												type: "string",
												maxLength: 50
											},
											number: {
												type: "string",
												maxLength: 8
											},
											number_suffix: {
												type: "string",
												maxLength: 6
											},
											box_number: {
												type: "string",
												maxLength: 8
											},
											area: {
												type: "string",
												maxLength: 35
											},
											person: {
												type: "string",
												maxLength: 50,
												minLength: 1
											},
											company: {
												type: "string",
												maxLength: 50
											},
											email: { anyOf: [{
												type: "string",
												format: "email"
											}, {
												type: "string",
												maxLength: 0
											}] },
											secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
											phone: {
												type: "string",
												maxLength: 25
											},
											eori_number: { type: ["string", "null"] },
											vat_number: { type: ["string", "null"] }
										}
									},
									recipients: {
										type: "array",
										minItems: 1,
										items: { type: "number" }
									},
									physical_properties: {
										type: "object",
										required: ["weight"],
										additionalProperties: !1,
										properties: {
											weight: {
												type: "integer",
												minimum: 0,
												maximum: 999999999
											},
											height: { type: "integer" },
											width: { type: "integer" },
											length: { type: "integer" },
											volume: { type: "integer" }
										}
									},
									options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
									customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
									carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
									pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
									drop_off_point: {
										type: ["object", "null"],
										required: [
											"location_code",
											"postal_code",
											"location_name",
											"city",
											"street",
											"number"
										],
										additionalProperties: !1,
										properties: {
											postal_code: { type: "string" },
											location_name: { type: "string" },
											city: { type: "string" },
											street: { type: "string" },
											number: { type: "string" },
											number_suffix: { type: "string" },
											box_number: { type: "string" },
											region: { type: "string" },
											state: { type: "string" },
											cc: { type: "string" },
											location_code: { type: "string" },
											retail_network_id: { type: "string" }
										}
									},
									note: { type: "string" },
									status: {
										type: "integer",
										enum: [
											1,
											2,
											3,
											4,
											5,
											6,
											7,
											8
										]
									},
									delivered: {
										type: "integer",
										enum: [0]
									},
									general_settings: {
										type: "object",
										additionalProperties: !1,
										properties: { save_recipient_address: {
											type: "integer",
											enum: [0, 1]
										} }
									},
									hidden: {
										type: "integer",
										enum: [0, 1]
									},
									shipped_items: {
										type: "array",
										minItems: 0,
										items: {
											type: "object",
											required: ["order_line_identifier", "quantity"],
											properties: {
												order_line_identifier: { type: "string" },
												quantity: {
													type: "integer",
													minimum: 1
												}
											}
										}
									}
								}
							}
						},
						collection_contact: {
							required: [
								"cc",
								"city",
								"company",
								"email",
								"last_name",
								"number",
								"phone",
								"postal_code",
								"street"
							],
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								city: {
									type: "string",
									maxLength: 255,
									minLength: 1
								},
								company: { type: ["string"] },
								email: {
									type: "string",
									format: "email"
								},
								first_name: { type: "string" },
								gender: {
									type: "string",
									enum: ["mr", "mrs"]
								},
								last_name: { type: "string" },
								number: {
									type: ["string", "integer"],
									minLength: 1
								},
								number_suffix: { type: ["string", "null"] },
								phone: {
									type: "string",
									minLength: 8
								},
								postal_code: {
									type: "string",
									minLength: 1
								},
								street: {
									type: "string",
									minLength: 1
								},
								street_additional_info: { type: ["string", "null"] }
							},
							type: "object"
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						},
						shipped_items: {
							type: "array",
							minItems: 0,
							items: {
								type: "object",
								required: ["order_line_identifier", "quantity"],
								properties: {
									order_line_identifier: { type: "string" },
									quantity: {
										type: "integer",
										minimum: 1
									}
								}
							}
						}
					}
				}
			}
		}
	} }
}, Qm = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	maxItems: 4,
	items: { anyOf: [{
		type: "string",
		format: "email"
	}, {
		type: "string",
		maxLength: 0
	}] }
}, $m = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"cc",
		"postal_code",
		"city",
		"street",
		"person"
	],
	properties: {
		cc: {
			type: "string",
			minLength: 2,
			maxLength: 2
		},
		postal_code: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: "string" },
		number_suffix: { type: "string" },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		person: { type: "string" },
		company: { type: "string" },
		phone: { type: "string" },
		email: { anyOf: [
			{
				type: "string",
				format: "email"
			},
			{
				type: "string",
				maxLength: 0
			},
			{ type: "null" }
		] }
	},
	additionalProperties: !1
}, eh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		postal_code: { type: "string" },
		location_name: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		state: {
			type: "string",
			maxLength: 2
		},
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		location_code: { type: "string" },
		location_type: { anyOf: [{ $ref: "#/components/schemas/_ref_shipment_bpost_bpost_pugo_type" }, { $ref: "#/components/schemas/_ref_shipment_location_type" }] },
		retail_network_id: { type: "string" }
	},
	additionalProperties: !1
}, th = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		required: ["shipments"],
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: [
						"carrier",
						"recipient",
						"options"
					],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								}
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						"multi-colli": {
							type: ["object", "null"],
							required: ["amount"],
							additionalProperties: !1,
							properties: { amount: { type: "integer" } }
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						}
					}
				}
			}
		}
	} }
}, nh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"parent",
					"carrier",
					"email",
					"name"
				],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					parent: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, rh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { options: {
		type: "object",
		allOf: [
			{ $ref: "#/components/schemas/_ref_shipment_options_package_type_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
			{ $ref: "#/components/schemas/_ref_shipment_options_options_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
		],
		properties: {
			contribution: {
				allOf: [{ $ref: "#/components/schemas/_ref_types_money" }],
				properties: { amount: { maximum: 1e5 } }
			},
			printerless_return: { $ref: "#/components/schemas/_ref_types_int_boolean" }
		}
	} }
}, ih = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: {
		type: "integer",
		enum: [
			1,
			2,
			6
		],
		anyOf: [
			{ $ref: "#/components/schemas/_ref_shipment_package_type_1_package" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_2_mailbox" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_6_small_package" }
		]
	} }
}, ah = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [1],
	title: "Package",
	description: "Regular package."
}, oh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [2],
	title: "Mailbox",
	description: "Shipment that fits through a mailbox slot."
}, sh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [6],
	title: "Small Package"
}, ch = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" }
	}
}, lh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [
		1,
		2,
		4,
		9,
		10,
		11,
		14,
		15,
		17,
		18
	]
}, uh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: ["carrier"],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					cc: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, dh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"recipient",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							},
							eori_number: { type: ["string", "null"] },
							vat_number: { type: ["string", "null"] }
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					drop_off_point: {
						type: ["object", "null"],
						required: [
							"location_code",
							"postal_code",
							"location_name",
							"city",
							"street",
							"number"
						],
						additionalProperties: !1,
						properties: {
							postal_code: { type: "string" },
							location_name: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: { type: "string" },
							region: { type: "string" },
							state: { type: "string" },
							cc: { type: "string" },
							location_code: { type: "string" },
							retail_network_id: { type: "string" }
						}
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					multi_collo_main_shipment_id: { type: ["integer", "null"] },
					secondary_shipments: {
						type: "array",
						minItems: 1,
						items: {
							type: "object",
							additionalProperties: !1,
							properties: {
								id: { type: "integer" },
								account_id: { type: "integer" },
								shop_id: { type: "integer" },
								reference_identifier: {
									type: ["integer", "string"],
									maxLength: 255,
									pattern: "^[^=\\?]*$"
								},
								recipient: {
									type: "object",
									additionalProperties: !1,
									properties: {
										cc: {
											type: "string",
											minLength: 2,
											maxLength: 2
										},
										region: {
											type: "string",
											maxLength: 35
										},
										state: {
											type: "string",
											maxLength: 2
										},
										postal_code: {
											type: "string",
											maxLength: 10
										},
										city: {
											type: "string",
											maxLength: 35,
											minLength: 1
										},
										street: {
											type: "string",
											maxLength: 40,
											minLength: 1
										},
										street_additional_info: {
											type: "string",
											maxLength: 50
										},
										number: {
											type: ["string", "null"],
											maxLength: 8
										},
										number_suffix: {
											type: ["string", "null"],
											maxLength: 6
										},
										box_number: {
											type: "string",
											maxLength: 8
										},
										area: {
											type: "string",
											maxLength: 35
										},
										person: {
											type: "string",
											maxLength: 50,
											minLength: 1
										},
										company: {
											type: "string",
											maxLength: 50
										},
										email: { anyOf: [{
											type: "string",
											format: "email"
										}, {
											type: "string",
											maxLength: 0
										}] },
										secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
										phone: {
											type: "string",
											maxLength: 25
										},
										eori_number: { type: ["string", "null"] },
										vat_number: { type: ["string", "null"] }
									}
								},
								recipients: {
									type: "array",
									minItems: 1,
									items: { type: "number" }
								},
								physical_properties: {
									type: "object",
									required: ["weight"],
									additionalProperties: !1,
									properties: {
										weight: {
											type: "integer",
											minimum: 0,
											maximum: 999999999
										},
										height: { type: "integer" },
										width: { type: "integer" },
										length: { type: "integer" },
										volume: { type: "integer" }
									}
								},
								options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
								customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
								carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
								pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
								drop_off_point: {
									type: ["object", "null"],
									required: [
										"location_code",
										"postal_code",
										"location_name",
										"city",
										"street",
										"number"
									],
									additionalProperties: !1,
									properties: {
										postal_code: { type: "string" },
										location_name: { type: "string" },
										city: { type: "string" },
										street: { type: "string" },
										number: { type: "string" },
										number_suffix: { type: "string" },
										box_number: { type: "string" },
										region: { type: "string" },
										state: { type: "string" },
										cc: { type: "string" },
										location_code: { type: "string" },
										retail_network_id: { type: "string" }
									}
								},
								note: { type: "string" },
								status: {
									type: "integer",
									enum: [
										1,
										2,
										3,
										4,
										5,
										6,
										7,
										8
									]
								},
								delivered: {
									type: "integer",
									enum: [0, 1]
								},
								general_settings: {
									type: "object",
									additionalProperties: !1,
									properties: { save_recipient_address: {
										type: "integer",
										enum: [0, 1]
									} }
								},
								multi_collo_main_shipment_id: { type: ["integer", "null"] },
								hidden: {
									type: "integer",
									enum: [0, 1]
								},
								shipped_items: {
									type: "array",
									minItems: 0,
									items: {
										type: "object",
										required: ["order_line_identifier", "quantity"],
										properties: {
											order_line_identifier: { type: "string" },
											quantity: {
												type: "integer",
												minimum: 1
											}
										}
									}
								}
							}
						}
					},
					collection_contact: {
						required: [
							"cc",
							"city",
							"number",
							"phone",
							"postal_code",
							"street"
						],
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							city: {
								type: "string",
								maxLength: 255,
								minLength: 1
							},
							company: { type: ["string", "null"] },
							email: {
								type: "string",
								format: "email"
							},
							first_name: { type: "string" },
							gender: {
								type: "string",
								enum: ["mr", "mrs"]
							},
							last_name: { type: "string" },
							number: {
								type: ["string", "integer"],
								minLength: 1
							},
							number_suffix: { type: ["string", "null"] },
							phone: {
								type: "string",
								minLength: 8
							},
							postal_code: {
								type: "string",
								minLength: 1
							},
							street: {
								type: "string",
								minLength: 1
							},
							street_additional_info: { type: ["string", "null"] }
						},
						type: "object"
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					},
					shipped_items: {
						type: "array",
						minItems: 0,
						items: {
							type: "object",
							required: ["order_line_identifier", "quantity"],
							properties: {
								order_line_identifier: { type: "string" },
								quantity: {
									type: "integer",
									minimum: 1
								}
							}
						}
					}
				}
			}
		} }
	} }
}, fh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"recipient",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							}
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					}
				}
			}
		} }
	} }
}, ph = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities V2",
	type: "object",
	required: ["recipient"],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the capabilities are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the capabilities are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				freshFood: {
					type: "object",
					additionalProperties: !1,
					description: "Fresh food delivery option"
				},
				frozen: {
					type: "object",
					additionalProperties: !1,
					description: "Frozen delivery option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: {
					oneOf: [{
						type: "object",
						additionalProperties: !1,
						maxProperties: 0
					}, { $ref: "#/components/schemas/_ref_types_money" }],
					description: "Insurance option. Empty object selects the carrier-default coverage. A Money object with amount > 0 requests a specific coverage in minor units; amount 0 (or empty currency) is treated as no insurance requested."
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "Ship without track and trace option"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				printReturnLabelAtDropOff: {
					type: "object",
					additionalProperties: !1,
					description: "Print return label at drop off package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"EARLY_MORNING_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the capabilities are requested."
		},
		pickup: {
			type: "object",
			description: "Pickup location criteria for filtering capabilities.",
			additionalProperties: !1,
			properties: { location: {
				type: "object",
				description: "Pickup location details.",
				additionalProperties: !1,
				properties: { type: { $ref: "#/components/schemas/_ref_shipment_location_type-v2" } }
			} }
		}
	}
}, mh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Pickup / drop-off location type used for capability and rates filtering.",
	type: "string",
	enum: [
		"RETAIL",
		"LOCKER",
		"POST_OFFICE"
	],
	oneOf: [
		{
			enum: ["RETAIL"],
			title: "Retail",
			description: "Shops/postal points."
		},
		{
			enum: ["LOCKER"],
			title: "Locker",
			description: "Automated parcel locker."
		},
		{
			enum: ["POST_OFFICE"],
			title: "PostOffice",
			description: "Post office location."
		}
	],
	"x-enum-varnames": [
		"Retail",
		"Locker",
		"PostOffice"
	]
}, hh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		additionalProperties: !1,
		properties: { capabilities: {
			type: "array",
			items: {
				type: "object",
				required: ["recipient"],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the capabilities are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the capabilities are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7
						]
					},
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							fresh_food: {
								type: "object",
								additionalProperties: !1,
								description: "Fresh food delivery option"
							},
							frozen: {
								type: "object",
								additionalProperties: !1,
								description: "Frozen delivery option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							printerless_return: {
								type: "object",
								additionalProperties: !1,
								description: "Printerless return delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							no_tracking: {
								type: "object",
								additionalProperties: !1,
								description: "Ship without track and trace option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "DEPRECATED: replaced by no_tracking (its inverse)."
							},
							insurance: {
								oneOf: [{
									type: "object",
									additionalProperties: !1,
									maxProperties: 0
								}, { $ref: "#/components/schemas/_ref_types_money" }],
								description: "Insurance option. Empty object selects the carrier-default coverage. A Money object with amount > 0 requests a specific coverage in minor units; amount 0 (or empty currency) is treated as no insurance requested."
							}
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the capabilities are requested."
					},
					pickup: {
						type: "object",
						description: "Pickup location criteria for filtering capabilities.",
						additionalProperties: !1,
						properties: { location_type: { $ref: "#/components/schemas/_ref_shipment_location_type" } }
					}
				}
			}
		} }
	} }
}, gh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account, v2 format",
	type: "object",
	additionalProperties: !1,
	properties: { carrier: {
		type: "string",
		enum: [
			"BRT",
			"DHL_EUROPLUS",
			"DHL_PARCEL_CONNECT",
			"DPD",
			"DHL_FOR_YOU",
			"INPOST",
			"POSTNL"
		]
	} }
}, _h = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account",
	type: "object",
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { carrier_id: {
			type: "integer",
			format: "int32",
			enum: [
				1,
				4,
				9,
				10,
				11,
				15,
				17
			]
		} }
	} }
}, vh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates V2",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"recipient"
	],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the rates are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the rates are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					description: "Whether this is a business address."
				}
			}
		},
		pickup: { $ref: "#/components/schemas/_ref_shipment_pickup-v2" },
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				freshFood: {
					type: "object",
					additionalProperties: !1,
					description: "Fresh food option"
				},
				frozen: {
					type: "object",
					additionalProperties: !1,
					description: "Frozen option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: { $ref: "#/components/schemas/_ref_types_money" },
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "Ship without track and trace option"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					required: ["dueAmount"],
					properties: { dueAmount: { $ref: "#/components/schemas/_ref_types_money" } },
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EARLY_MORNING_DELIVERY",
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the rates are requested."
		},
		collo: {
			type: "integer",
			minimum: 1,
			description: "The number of collo for which the rates are requested."
		}
	}
}, yh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	description: "Pickup location data.",
	required: ["address", "location"],
	properties: {
		address: { $ref: "#/components/schemas/_ref_shipment_address-v2" },
		location: { $ref: "#/components/schemas/_ref_shipment_location-v2" },
		retailNetworkId: {
			type: "string",
			enum: ["PNPNL-01", "PNPBE-01"],
			description: "PostNL Retail network ID."
		}
	},
	additionalProperties: !1
}, bh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: {
			type: "string",
			minLength: 2,
			maxLength: 2,
			pattern: "[A-Z]{2}",
			description: "The country code (ISO 3166-1 alpha-2) of the address."
		},
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address. Only applicable for `countryCode`=`BE`."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: ["countryCode"]
}, xh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the pickup location."
		},
		code: {
			type: "string",
			minLength: 1,
			maxLength: 64,
			description: "The location code of the pickup location."
		},
		type: { $ref: "#/components/schemas/_ref_shipment_location_type-v2" }
	},
	required: ["name"],
	additionalProperties: !1
}, Sh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["rates"],
		additionalProperties: !1,
		properties: { rates: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"carrier_id",
					"package_type",
					"recipient"
				],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the rates are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the rates are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								description: "Whether this is a business address."
							}
						}
					},
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								required: ["due_amount"],
								properties: { due_amount: { $ref: "#/components/schemas/_ref_types_money" } },
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							cooled_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cooled delivery option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							no_tracking: {
								type: "object",
								additionalProperties: !1,
								description: "Ship without track and trace option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "DEPRECATED: replaced by no_tracking (its inverse)."
							},
							insurance: { $ref: "#/components/schemas/_ref_types_money" }
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the rates are requested."
					},
					collo: {
						type: "integer",
						minimum: 1,
						description: "The number of collo for which the rates are requested."
					}
				}
			}
		} }
	} }
}, Ch = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "POST notification groups",
	type: "object",
	oneOf: [{
		type: "object",
		required: [
			"shopId",
			"packageType",
			"countryCode",
			"shipmentDirection"
		],
		properties: {
			shopId: { type: "integer" },
			packageType: {
				type: "string",
				enum: [
					"DIGITAL_STAMP",
					"ENVELOPE",
					"UNFRANKED",
					"MAILBOX",
					"PACKAGE",
					"PALLET",
					"SMALL_PACKAGE"
				]
			},
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["OUTBOUND"]
			}
		},
		additionalProperties: !1
	}, {
		type: "object",
		required: ["shopId", "shipmentDirection"],
		properties: {
			shopId: { type: "integer" },
			packageType: { type: "null" },
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["INBOUND"]
			}
		},
		additionalProperties: !1
	}]
}, wh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "PUT notification templates",
	type: "object",
	required: ["body", "subject"],
	properties: {
		body: {
			type: "string",
			minLength: 1
		},
		subject: {
			type: "string",
			minLength: 1,
			maxLength: 255
		}
	},
	additionalProperties: !1
}, Th = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions V1.1",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.1" }
		} }
	} }
}, Eh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, Dh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.0" }
		} }
	} }
}, Oh = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, $ = (e) => typeof e == "object" && !!e && !Array.isArray(e), kh = (e) => $(e) && "data" in e && $(e.data), Ah = (e) => e.data, jh = (e) => $(e) && Array.isArray(e.errors) && e.errors.some((e) => $(e) && Object.keys(e).some((e) => /^\d+$/.test(e))), Mh = (e) => e.errors.flatMap((e) => Object.keys(e).filter((e) => /^\d+$/.test(e)).map(Number)), Nh = (e) => {
	if (!$(e) || !("errors" in e)) return !1;
	let { errors: t } = e;
	return Array.isArray(t) || $(t);
}, Ph = (e) => (Array.isArray(e.errors) ? e.errors : Object.values(e.errors)).filter($).map((e) => e.code).filter((e) => typeof e == "number"), Fh = (e) => $(e) && typeof e.code == "number", Ih = (e) => [e.code], Lh = (e) => {
	let t = kh(e) ? Ah(e) : e;
	return jh(t) ? Mh(t) : Nh(t) ? Ph(t) : Fh(t) ? Ih(t) : [];
}, Rh = {
	[Q.EarlyMorning]: X.EARLY_MORNING,
	[Q.Morning]: X.MORNING,
	[Q.Standard]: X.STANDARD,
	[Q.Evening]: X.EVENING,
	[Q.Pickup]: X.PICKUP,
	[Q.PickupExpress]: X.PICKUP,
	[Q.SameDayDelivery]: X.SAME_DAY,
	[Q.Express]: X.EXPRESS
}, zh = (e) => {
	if (e) return Rh[e];
}, Bh = (e) => {
	switch (e.unit) {
		case "g": return e.value;
		case "kg": return e.value * yl.getWeightFactor(vl.Kilogram);
		default: throw Error(`Unsupported unit: ${e.unit}`);
	}
};
//#endregion
export { Xc as AccountDefsPlatformId, Hc as AccountDefsPlatformName, nl as AccountParametersPlatformId, ol as BillingDefsCurrency, Wc as CommonDefsDayOfWeek, $c as CommonDefsIsoDayOfWeek, ll as CommonDefsTimeZoneType, Gc as CommonErrorUserCodeAuth, qc as CommonHttpStatusCode4XxClientError400BadRequest, rl as CommonHttpStatusCode4XxClientError401Unauthorized, el as CommonHttpStatusCode4XxClientError404NotFound, Yc as CommonHttpStatusCode4XxClientError406NotAcceptable, Jc as CommonHttpStatusCode4XxClientError415UnsupportedMediaType, Vc as CommonParametersFilterValidateBool, ul as CommonParametersOrder, pl as RefCapabilitiesSharedCarrier, Uc as RefCapabilitiesSharedCarrierV2, fl as RefNotificationNotificationTemplateType, Nc as RefShipmentBpostBpostPugoType, yc as RefShipmentLabelPrintingPosition, dl as RefShipmentLocationType, Pc as RefShipmentLocationTypeV2, xc as RefShipmentPackageType, bc as RefShipmentPackageType1Package, Z as RefShipmentPackageType2Mailbox, Qc as RefShipmentPackageType6SmallPackage, _c as RefShipmentPackageTypeV2, Zc as RefShipmentShipmentTypeV2, Oc as RefShipmentTransactionStatus, kc as RefShipmentType, Ac as RefTypesCarrier, Sc as RefTypesCarrierReturns, Tc as RefTypesDeliveryType, X as RefTypesDeliveryTypeV2, Mc as RefTypesIntBoolean, ml as RefTypesMoneyPropertiesCurrency, vc as RefTypesShipmentType, Ic as RefTypesTransactionTypes, wc as ShipmentDefsCustomsShipmentType, Fc as ShipmentDefsDeliveryMomentPropertiesType, Lc as ShipmentDefsDeliveryOptionsDeliveryNameV2, Cc as ShipmentDefsExternalProviderPropertiesDisplayName, Dc as ShipmentDefsMainStatus, il as ShipmentDefsShipmentPaymentStatus, Ec as ShipmentDefsShipmentStatus, sl as ShipmentOptions, zc as ShipmentParametersCarrierId, Rc as ShipmentParametersCarrierName, Bc as ShipmentParametersDeliveryType, jc as ShipmentParametersPaperSize, gc as ShipmentParametersSortShipment, Kc as ShipmentResponsesDeliveryOptionsPackageTypeV2, cl as SortTracktraces, Wp as _ref_capabilities_contract_definitions_response_contract_definitions_v1Schema, zp as _ref_capabilities_contract_definitions_response_contract_definitions_v2Schema, qp as _ref_capabilities_contract_definitions_response_options_insurance_option_v1Schema, Hp as _ref_capabilities_contract_definitions_response_options_insurance_option_v2Schema, Kp as _ref_capabilities_contract_definitions_response_options_option_v1Schema, Vp as _ref_capabilities_contract_definitions_response_options_option_v2Schema, Gp as _ref_capabilities_contract_definitions_response_options_options_v1Schema, Bp as _ref_capabilities_contract_definitions_response_options_options_v2Schema, Op as _ref_capabilities_response_capability_v1Schema, dp as _ref_capabilities_response_capability_v2Schema, Ep as _ref_capabilities_response_colloSchema, Fp as _ref_capabilities_response_options_insurance_option_v1Schema, yp as _ref_capabilities_response_options_insurance_option_v2Schema, Pp as _ref_capabilities_response_options_option_v1Schema, vp as _ref_capabilities_response_options_option_v2Schema, jp as _ref_capabilities_response_options_options_v1Schema, hp as _ref_capabilities_response_options_options_v2Schema, Lp as _ref_capabilities_response_physical_properties_physical_properties_v1Schema, xp as _ref_capabilities_response_physical_properties_physical_properties_v2Schema, Sp as _ref_capabilities_response_physical_properties_physical_propertySchema, kp as _ref_capabilities_shared_carrierSchema, fp as _ref_capabilities_shared_carrier_v2Schema, Ap as _ref_capabilities_shared_contract_v1Schema, pp as _ref_capabilities_shared_contract_v2Schema, Np as _ref_capabilities_shared_options_base_option_v1Schema, _p as _ref_capabilities_shared_options_base_option_v2Schema, Mp as _ref_capabilities_shared_options_base_options_v1Schema, gp as _ref_capabilities_shared_options_base_options_v2Schema, Ip as _ref_capabilities_shared_options_insurance_base_insurance_v1Schema, bp as _ref_capabilities_shared_options_insurance_base_insurance_v2Schema, lm as _ref_notification_notification_template_typeSchema, om as _ref_notification_response_notification_groupSchema, cm as _ref_notification_response_notification_templateSchema, tm as _ref_rates_response_contractSchema, Yp as _ref_rates_response_contract_v2Schema, rm as _ref_rates_response_price_composition_price_composition_v1Schema, Zp as _ref_rates_response_price_composition_price_composition_v2Schema, im as _ref_rates_response_price_composition_price_v1Schema, Qp as _ref_rates_response_price_composition_price_v2Schema, em as _ref_rates_response_rate_v1Schema, Jp as _ref_rates_response_rate_v2Schema, bh as _ref_shipment_address_v2Schema, eu as _ref_shipment_bpost_bpost_pugo_typeSchema, tu as _ref_shipment_customs_declarationSchema, ru as _ref_shipment_customs_declaration_itemSchema, Zl as _ref_shipment_general_settingsSchema, Bm as _ref_shipment_label_printing_positionSchema, $l as _ref_shipment_location_typeSchema, mh as _ref_shipment_location_type_v2Schema, xh as _ref_shipment_location_v2Schema, Jl as _ref_shipment_options_delivery_type_allSchema, Yl as _ref_shipment_options_delivery_type_delivery_dateSchema, Vl as _ref_shipment_options_insuranceSchema, Bl as _ref_shipment_options_insurance_maxSchema, Xl as _ref_shipment_options_label_descriptionSchema, Ul as _ref_shipment_options_optionsSchema, ch as _ref_shipment_options_options_returnsSchema, Kl as _ref_shipment_options_package_type_allSchema, ih as _ref_shipment_options_package_type_returnsSchema, ql as _ref_shipment_package_typeSchema, ah as _ref_shipment_package_type_1_packageSchema, oh as _ref_shipment_package_type_2_mailboxSchema, sh as _ref_shipment_package_type_6_small_packageSchema, mp as _ref_shipment_package_type_v2Schema, ou as _ref_shipment_physical_properties_properties_heightSchema, cu as _ref_shipment_physical_properties_properties_lengthSchema, lu as _ref_shipment_physical_properties_properties_volumeSchema, au as _ref_shipment_physical_properties_properties_weightSchema, su as _ref_shipment_physical_properties_properties_widthSchema, eh as _ref_shipment_pickupSchema, yh as _ref_shipment_pickup_v2Schema, Qm as _ref_shipment_recipient_secondary_emailsSchema, hu as _ref_shipment_reference_identifierSchema, $m as _ref_shipment_senderSchema, zl as _ref_shipment_shipment_optionsSchema, rh as _ref_shipment_shipment_options_returnsSchema, Xp as _ref_shipment_shipment_type_v2Schema, gu as _ref_shipment_transaction_statusSchema, Ml as _ref_shipment_typeSchema, wu as _ref_types_carrierSchema, lh as _ref_types_carrier_returnsSchema, Fl as _ref_types_ccSchema, hf as _ref_types_delivery_typeSchema, wp as _ref_types_delivery_type_v2Schema, Wl as _ref_types_int_booleanSchema, Gl as _ref_types_moneySchema, vu as _ref_types_money_nullable_amountSchema, bu as _ref_types_money_properties_amountSchema, yu as _ref_types_money_properties_currencySchema, Hl as _ref_types_price_euroSchema, nm as _ref_types_shipment_typeSchema, Tp as _ref_types_transaction_typesSchema, Cp as _ref_types_value_with_unitSchema, Oh as _ref_webhook_webhook_v1_0Schema, Eh as _ref_webhook_webhook_v1_1Schema, Al as account_defs_account_properties_idSchema, nd as account_defs_contactSchema, Il as account_defs_contact_properties_emailSchema, dd as account_defs_location_properties_box_numberSchema, ld as account_defs_location_properties_ccSchema, cd as account_defs_location_properties_citySchema, ad as account_defs_location_properties_numberSchema, od as account_defs_location_properties_number_suffixSchema, sd as account_defs_location_properties_postal_codeSchema, ud as account_defs_location_properties_regionSchema, rd as account_defs_location_properties_streetSchema, id as account_defs_location_properties_street_additional_infoSchema, Eu as account_defs_platform_idSchema, Lm as account_defs_platform_nameSchema, Tu as account_defs_platform_properties_idSchema, jl as account_defs_shop_properties_idSchema, zd as account_defs_user_properties_idSchema, Rm as account_parameters_platform_idSchema, Im as account_parameters_platform_identifierSchema, yd as billing_defs_currencySchema, Jd as billing_defs_payment_dataSchema, Kd as billing_defs_shipment_dataSchema, hh as capabilities_post_capabilities_request_v1Schema, ph as capabilities_post_capabilities_request_v2Schema, _h as capabilities_post_contract_definitions_request_v1Schema, gh as capabilities_post_contract_definitions_request_v2Schema, Dp as capabilities_responses_capabilities_v1Schema, up as capabilities_responses_capabilities_v2Schema, Up as capabilities_responses_contract_definitions_v1Schema, Rp as capabilities_responses_contract_definitions_v2Schema, uf as common_defs_dateSchema, Pd as common_defs_date_and_timeSchema, tf as common_defs_date_timeSchema, Af as common_defs_day_of_weekSchema, Ef as common_defs_download_urlSchema, jf as common_defs_iso_day_of_weekSchema, vf as common_defs_latitudeSchema, yf as common_defs_longitudeSchema, Yd as common_defs_priceSchema, ff as common_defs_timeSchema, nf as common_defs_time_zone_typeSchema, Nd as common_defs_timestamps_properties_createdSchema, Rd as common_defs_timestamps_properties_created_bySchema, Id as common_defs_timestamps_properties_modifiedSchema, Vd as common_defs_timestamps_properties_modified_bySchema, Qf as common_error_systemSchema, Cl as common_error_userSchema, wl as common_error_user_codeSchema, Tl as common_error_user_code_authSchema, Sl as common_http_status_code_4xx_client_errorSchema, Zd as common_http_status_code_4xx_client_error_400_bad_requestSchema, zf as common_http_status_code_4xx_client_error_401_unauthorizedSchema, El as common_http_status_code_4xx_client_error_404_not_foundSchema, wf as common_http_status_code_4xx_client_error_406_not_acceptableSchema, Lf as common_http_status_code_4xx_client_error_415_unsupported_media_typeSchema, Sf as common_http_status_code_5xx_server_errorSchema, xf as common_http_status_code_errorSchema, Um as common_parameters_bigidSchema, Hm as common_parameters_bigidsSchema, Sm as common_parameters_booleanSchema, bm as common_parameters_country_codeSchema, Cm as common_parameters_filter_validate_boolSchema, Km as common_parameters_idSchema, Gm as common_parameters_idsSchema, jm as common_parameters_latitudeSchema, Mm as common_parameters_longitudeSchema, Nm as common_parameters_orderSchema, Fm as common_parameters_pageSchema, qm as common_parameters_sizeSchema, Dm as common_parameters_weekday_digitSchema, Ud as common_responses_download_linkSchema, Wd as common_responses_download_link_definitions_urlSchema, Tf as common_responses_download_urlSchema, Qd as common_responses_problemSchema, Zf as common_responses_system_errorSchema, xl as common_responses_user_errorSchema, Xd as common_responses_user_error_bad_requestSchema, If as common_responses_user_error_invalid_content_typeSchema, Cf as common_responses_user_error_not_acceptableSchema, bl as common_responses_user_error_not_foundSchema, Rf as common_responses_user_error_permission_deniedSchema, as as coreApiAcceptanceUrl, eo as coreApiUrl, zo as deleteNotificationGroups, sa as deleteShipments, Vr as deleteWebhookSubscriptions, uo as disableAllNotificationTemplatesByGroup, Yo as disableNotificationTemplate, oi as enableAllNotificationTemplatesByGroup, Fa as enableNotificationTemplate, bf as errorSchema, hs as getDeliveryOptions, gi as getDropOffPoints, Lh as getErrorCodes, Pi as getIndex, xo as getNotificationGroups, Ga as getNotificationTemplates, Qi as getPickupLocations, Ui as getShipments, Mr as getShipmentsById, Ts as getShipmentsLabels, Qs as getTrackTraces, Zr as getTrackTracesByIds, Us as getWebhookSubscriptions, mn as getWebhookSubscriptionsById, zh as mapAdjustedDeliveryType, tl as mapPickupLocationTypeV1ToV2, al as mapPickupLocationTypeV2ToV1, Bh as mapServiceWeightToGrams, Ch as notification_post_notification_group_requestSchema, wh as notification_put_notification_template_requestSchema, am as notification_responses_notification_groupsSchema, sm as notification_responses_notification_templatesSchema, Ad as order_defs_shipped_item_properties_order_lineSchema, kd as order_defs_shipped_item_properties_order_line_identifierSchema, jd as order_defs_shipped_item_properties_picklist_identifierSchema, Od as order_defs_shipped_item_properties_quantitySchema, S as postCapabilities, Ps as postCapabilitiesContractDefinitions, Cn as postNotificationGroups, B as postRates, j as postShipments, jt as postUnrelatedReturnShipments, Ea as postWebhookSubscriptions, i as putNotificationTemplate, _a as putShipment, Sh as rates_post_rates_request_v1Schema, vh as rates_post_rates_request_v2Schema, $p as rates_responses_rates_v1Schema, pt as sendTestNotification, op as shipment_defs_carrier_track_trace_eventSchema, ap as shipment_defs_carrier_track_trace_historySchema, nu as shipment_defs_customs_shipment_typeSchema, cp as shipment_defs_delivery_moment_properties_time_frameSchema, sp as shipment_defs_delivery_moment_properties_typeSchema, af as shipment_defs_delivery_options_delivery_name_v2Schema, sf as shipment_defs_delivery_options_delivery_time_frameSchema, gf as shipment_defs_delivery_options_opening_hoursSchema, _f as shipment_defs_delivery_options_opening_hours_definitions_opening_hoursSchema, pf as shipment_defs_delivery_options_pickupSchema, mf as shipment_defs_delivery_options_pickup_timeSchema, xu as shipment_defs_external_provider_properties_display_nameSchema, Su as shipment_defs_external_provider_properties_idSchema, np as shipment_defs_external_track_trace_linkSchema, ip as shipment_defs_main_statusSchema, Mf as shipment_defs_occupancySchema, Ol as shipment_defs_shipmentSchema, md as shipment_defs_shipment_carrier_properties_external_identifierSchema, _u as shipment_defs_shipment_drop_off_pointSchema, Du as shipment_defs_shipment_origin_properties_originSchema, Ou as shipment_defs_shipment_origin_properties_user_agentSchema, Cd as shipment_defs_shipment_partner_tracktracesSchema, Cu as shipment_defs_shipment_payment_statusSchema, iu as shipment_defs_shipment_physical_propertiesSchema, du as shipment_defs_shipment_physical_properties_properties_heightSchema, pu as shipment_defs_shipment_physical_properties_properties_lengthSchema, mu as shipment_defs_shipment_physical_properties_properties_volumeSchema, uu as shipment_defs_shipment_physical_properties_properties_weightSchema, fu as shipment_defs_shipment_physical_properties_properties_widthSchema, Ql as shipment_defs_shipment_pickupSchema, Au as shipment_defs_shipment_properties_account_idSchema, _d as shipment_defs_shipment_properties_amountSchema, Ku as shipment_defs_shipment_properties_barcodeSchema, Zu as shipment_defs_shipment_properties_carrier_idSchema, td as shipment_defs_shipment_properties_collection_contactSchema, bd as shipment_defs_shipment_properties_contract_idSchema, Md as shipment_defs_shipment_properties_createdSchema, Ld as shipment_defs_shipment_properties_created_bySchema, vd as shipment_defs_shipment_properties_currencySchema, zu as shipment_defs_shipment_properties_customs_declarationSchema, hd as shipment_defs_shipment_properties_delayedSchema, gd as shipment_defs_shipment_properties_deliveredSchema, Uu as shipment_defs_shipment_properties_drop_off_pointSchema, pd as shipment_defs_shipment_properties_external_identifierSchema, Ju as shipment_defs_shipment_properties_external_providerSchema, Yu as shipment_defs_shipment_properties_external_provider_idSchema, Lu as shipment_defs_shipment_properties_general_settingsSchema, Wu as shipment_defs_shipment_properties_hiddenSchema, kl as shipment_defs_shipment_properties_idSchema, xd as shipment_defs_shipment_properties_link_consumer_portalSchema, Fd as shipment_defs_shipment_properties_modifiedSchema, Bd as shipment_defs_shipment_properties_modified_bySchema, fd as shipment_defs_shipment_properties_multi_collo_main_shipment_idSchema, Iu as shipment_defs_shipment_properties_optionsSchema, Td as shipment_defs_shipment_properties_order_shipment_identifierSchema, $u as shipment_defs_shipment_properties_originSchema, ku as shipment_defs_shipment_properties_parent_idSchema, Sd as shipment_defs_shipment_properties_partner_tracktracesSchema, Xu as shipment_defs_shipment_properties_payment_statusSchema, Bu as shipment_defs_shipment_properties_physical_propertiesSchema, Ru as shipment_defs_shipment_properties_pickupSchema, wd as shipment_defs_shipment_properties_pickup_request_numberSchema, Qu as shipment_defs_shipment_properties_platform_idSchema, Gu as shipment_defs_shipment_properties_priceSchema, Nu as shipment_defs_shipment_properties_recipientSchema, Vu as shipment_defs_shipment_properties_reference_identifierSchema, qu as shipment_defs_shipment_properties_regionSchema, Pu as shipment_defs_shipment_properties_senderSchema, Mu as shipment_defs_shipment_properties_shipment_typeSchema, Ed as shipment_defs_shipment_properties_shipped_itemsSchema, ju as shipment_defs_shipment_properties_shop_idSchema, Fu as shipment_defs_shipment_properties_statusSchema, Hu as shipment_defs_shipment_properties_transaction_statusSchema, ed as shipment_defs_shipment_properties_user_agentSchema, Nl as shipment_defs_shipment_recipientSchema, Pl as shipment_defs_shipment_senderSchema, Ll as shipment_defs_shipment_sender_properties_emailSchema, Dd as shipment_defs_shipment_shipped_itemSchema, Rl as shipment_defs_shipment_statusSchema, tp as shipment_defs_track_traceSchema, lp as shipment_defs_track_trace_proof_of_deliverySchema, rp as shipment_defs_tracking_locationSchema, hm as shipment_parameters_barcodeSchema, _m as shipment_parameters_carrier_idSchema, gm as shipment_parameters_carrier_identifierSchema, vm as shipment_parameters_carrier_nameSchema, ym as shipment_parameters_collect_dateSchema, xm as shipment_parameters_cutoff_timeSchema, wm as shipment_parameters_delivery_dateSchema, Em as shipment_parameters_delivery_options_identifierSchema, Tm as shipment_parameters_delivery_timeSchema, km as shipment_parameters_delivery_typeSchema, Om as shipment_parameters_delivery_typesSchema, zm as shipment_parameters_label_positionSchema, Pm as shipment_parameters_package_typeSchema, Am as shipment_parameters_paper_sizeSchema, Vm as shipment_parameters_postal_codeSchema, Wm as shipment_parameters_shipment_typeSchema, Jm as shipment_parameters_sort_shipmentSchema, Ym as shipment_parameters_statusSchema, Xm as shipment_parameters_tracktraces_extra_infoSchema, nh as shipment_post_return_shipments_requestSchema, th as shipment_post_shipments_requestSchema, Zm as shipment_post_shipments_request_v1_1Schema, uh as shipment_post_unrelated_return_shipments_requestSchema, fh as shipment_put_shipments_requestSchema, dh as shipment_put_shipments_request_v1_1Schema, Gd as shipment_responses_bulk_shipment_labels_payment_requiredSchema, lf as shipment_responses_delivery_options_delivery_option_v1Schema, ef as shipment_responses_delivery_options_delivery_option_v2Schema, rf as shipment_responses_delivery_options_delivery_possibilitySchema, df as shipment_responses_delivery_options_delivery_timeSchema, of as shipment_responses_delivery_options_package_type_v2Schema, cf as shipment_responses_delivery_options_v1Schema, $d as shipment_responses_delivery_options_v2Schema, Hd as shipment_responses_downloadable_labelSchema, Of as shipment_responses_drop_off_pointSchema, kf as shipment_responses_drop_off_point_definitions_available_daysSchema, Nf as shipment_responses_drop_off_point_definitions_opening_hoursSchema, Ff as shipment_responses_drop_off_point_definitions_timeframeSchema, Pf as shipment_responses_drop_off_point_definitions_timeframesSchema, Df as shipment_responses_drop_off_pointsSchema, qd as shipment_responses_payment_instructionsSchema, Bf as shipment_responses_pickup_locationsSchema, Hf as shipment_responses_pickup_locations_definitions_addressSchema, Wf as shipment_responses_pickup_locations_definitions_locationSchema, Gf as shipment_responses_pickup_locations_definitions_opening_hoursSchema, Vf as shipment_responses_pickup_locations_definitions_pickup_locationSchema, Uf as shipment_responses_pickup_locations_definitions_possibilitiesSchema, Kf as shipment_responses_pickup_locations_definitions_timeframeSchema, qf as shipment_responses_post_shipments_v1_2Schema, Dl as shipment_responses_put_shipments_v1_2Schema, Jf as shipment_responses_shipment_idsSchema, Xf as shipment_responses_shipment_ids_properties_data_properties_idsSchema, Yf as shipment_responses_shipment_labelsSchema, $f as shipment_responses_shipmentsSchema, ep as shipment_responses_tracktracesSchema, gl as useCoreApiService, hl as useShipmentCapabilitiesService, _l as useShipmentPricingService, Dh as webhooks_post_webhook_subscriptions_request_v1_0Schema, Th as webhooks_post_webhook_subscriptions_request_v1_1Schema, mm as webhooks_responses_post_webhook_subscriptionsSchema, fm as webhooks_responses_webhook_subscriptions_v1_0Schema, um as webhooks_responses_webhook_subscriptions_v1_1Schema, pm as webhooks_responses_webhook_v1_0Schema, dm as webhooks_responses_webhook_v1_1Schema, St as zAccountDefsAccountPropertiesId, Bt as zAccountDefsContact, Y as zAccountDefsContactPropertiesEmail, je as zAccountDefsLocationPropertiesBoxNumber, it as zAccountDefsLocationPropertiesCc, an as zAccountDefsLocationPropertiesCity, sc as zAccountDefsLocationPropertiesNumber, p as zAccountDefsLocationPropertiesNumberSuffix, Vn as zAccountDefsLocationPropertiesPostalCode, Se as zAccountDefsLocationPropertiesRegion, Mn as zAccountDefsLocationPropertiesStreet, Xn as zAccountDefsLocationPropertiesStreetAdditionalInfo, pe as zAccountDefsPlatformId, Ye as zAccountDefsPlatformName, Ao as zAccountDefsPlatformPropertiesId, Be as zAccountDefsShopPropertiesId, mr as zAccountDefsUserPropertiesId, ar as zAccountParametersPlatformId, Cr as zAccountParametersPlatformIdentifier, Yt as zBarcode, e as zBillingDefsCurrency, Ni as zBillingDefsPaymentData, ms as zBillingDefsShipmentData, lo as zCapabilitiesPostCapabilitiesRequestV1, Jo as zCapabilitiesPostCapabilitiesRequestV2, ga as zCapabilitiesPostContractDefinitionsRequestV1, Xr as zCapabilitiesPostContractDefinitionsRequestV2, bo as zCapabilitiesResponsesCapabilitiesV1, is as zCapabilitiesResponsesCapabilitiesV2, hi as zCapabilitiesResponsesContractDefinitionsV1, Wa as zCapabilitiesResponsesContractDefinitionsV2, ws as zCarrier, wi as zCarrierId, Hi as zCc, ko as zCity, $a as zCollectDate, oa as zCommonDefsDate, Zi as zCommonDefsDateAndTime, Br as zCommonDefsDateTime, Ns as zCommonDefsDayOfWeek, oc as zCommonDefsDownloadUrl, ai as zCommonDefsIsoDayOfWeek, Zs as zCommonDefsLatitude, Sn as zCommonDefsLongitude, A as zCommonDefsPrice, Hs as zCommonDefsTime, jn as zCommonDefsTimeZoneType, J as zCommonDefsTimestampsPropertiesCreated, z as zCommonDefsTimestampsPropertiesCreatedBy, zt as zCommonDefsTimestampsPropertiesModified, Pa as zCommonDefsTimestampsPropertiesModifiedBy, f as zCommonErrorSystem, Ta as zCommonErrorUser, xt as zCommonErrorUserCode, At as zCommonErrorUserCodeAuth, Jt as zCommonHttpStatusCode4XxClientError, fe as zCommonHttpStatusCode4XxClientError400BadRequest, ze as zCommonHttpStatusCode4XxClientError401Unauthorized, ft as zCommonHttpStatusCode4XxClientError404NotFound, pn as zCommonHttpStatusCode4XxClientError406NotAcceptable, hc as zCommonHttpStatusCode4XxClientError415UnsupportedMediaType, x as zCommonHttpStatusCode5XxServerError, Yn as zCommonHttpStatusCodeError, Ae as zCommonParametersBigid, Bn as zCommonParametersBigids, ir as zCommonParametersBoolean, xe as zCommonParametersCountryCode, rt as zCommonParametersFilterValidateBool, Ro as zCommonParametersId, Je as zCommonParametersIds, Sr as zCommonParametersLatitude, pr as zCommonParametersLongitude, jr as zCommonParametersOrder, rn as zCommonParametersPage, r as zCommonParametersSize, ki as zCommonParametersWeekdayDigit, us as zCommonResponsesDownloadLink, ao as zCommonResponsesDownloadLinkDefinitionsUrl, Wo as zCommonResponsesDownloadUrl, fa as zCommonResponsesProblem, Kr as zCommonResponsesSystemError, go as zCommonResponsesUserError, es as zCommonResponsesUserErrorBadRequest, di as zCommonResponsesUserErrorInvalidContentType, Ba as zCommonResponsesUserErrorNotAcceptable, bs as zCommonResponsesUserErrorNotFound, bi as zCommonResponsesUserErrorPermissionDenied, Ri as zCountryCode, To as zCreated, Ya as zCutOffTime, na as zCutoffTime, qi as zDelayed, Ir as zDeleteNotificationGroupsData, ks as zDeleteNotificationGroupsResponse, nc as zDeleteShipmentsData, ti as zDeleteShipmentsResponse, qs as zDeleteWebhookSubscriptionsData, vn as zDeleteWebhookSubscriptionsResponse, E as zDelivered, Rs as zDeliveryDate, Dn as zDeliveryOptionsIdentifier, W as zDeliveryTime, F as zDeliverydaysWindow, Ft as zDisableAllNotificationTemplatesByGroupData, Aa as zDisableAllNotificationTemplatesByGroupResponse, c as zDisableNotificationTemplateData, xa as zDisableNotificationTemplateResponse, _t as zDistance, Et as zDropoffDays, Wt as zDropoffDelay, ce as zDropoffToday, Fe as zEnableAllNotificationTemplatesByGroupData, ct as zEnableAllNotificationTemplatesByGroupResponse, ln as zEnableNotificationTemplateData, dc as zEnableNotificationTemplateResponse, _ as zError, Gn as zExcludeDeliveryType, Ee as zExcludeParcelLockers, In as zExternalIdentifier, er as zExtraInfoTracktraces, _e as zFilterHiddenShops, $e as zFormat, Po as zGetDeliveryOptionsData, We as zGetDeliveryOptionsResponse, vr as zGetDropOffPointsData, lr as zGetDropOffPointsResponse, Dr as zGetIndexData, $t as zGetIndexResponse, ne as zGetNotificationGroupsData, ji as zGetNotificationGroupsResponse, fs as zGetNotificationTemplatesData, so as zGetNotificationTemplatesResponse, Ko as zGetPickupLocationsData, ma as zGetPickupLocationsResponse, Jr as zGetShipmentsByIdData, vo as zGetShipmentsByIdResponse, ns as zGetShipmentsData, pi as zGetShipmentsLabelsData, Ha as zGetShipmentsLabelsResponse, Ss as zGetShipmentsResponse, Si as zGetTrackTracesByIdsData, Bi as zGetTrackTracesByIdsResponse, Do as zGetTrackTracesData, Za as zGetTrackTracesResponse, ia as zGetWebhookSubscriptionsByIdData, Yi as zGetWebhookSubscriptionsByIdResponse, Rr as zGetWebhookSubscriptionsData, js as zGetWebhookSubscriptionsResponse, ic as zHidden, ri as zHook, Ys as zIncludeSecondaryShipments, bn as zLatitude, O as zLimit, Bs as zLinkConsumerPortal, kn as zLocationName, K as zLongitude, L as zMaxCutOffTime, Lt as zMinCutOffTime, Ma as zMondayDelivery, u as zNotificationGroupId, Ca as zNotificationGroupIds, yt as zNotificationPostNotificationGroupRequest, Ot as zNotificationPutNotificationTemplateRequest, Kt as zNotificationResponsesNotificationGroups, ue as zNotificationResponsesNotificationTemplates, Le as zNotificationTemplateId, ut as zNumber, dn as zOrder, pc as zOrderDefsShippedItemPropertiesOrderLine, y as zOrderDefsShippedItemPropertiesOrderLineIdentifier, qn as zOrderDefsShippedItemPropertiesPicklistIdentifier, Oe as zOrderDefsShippedItemPropertiesQuantity, Rn as zPackageType, nr as zPage, ye as zPlatform, tt as zPositions, Io as zPostCapabilities, Ke as zPostCapabilitiesContractDefinitions, br as zPostCapabilitiesContractDefinitionsData, dr as zPostCapabilitiesContractDefinitionsResponse, kr as zPostCapabilitiesData, tn as zPostCapabilitiesResponse, ie as zPostNotificationGroups, Di as zPostNotificationGroupsData, cs as zPostNotificationGroupsResponse, ro as zPostRates, Ho as zPostRatesData, ua as zPostRatesResponse, Wr as zPostShipments, mo as zPostShipmentsData, Qo as zPostShipmentsResponse, li as zPostUnrelatedReturnShipmentsData, Ra as zPostUnrelatedReturnShipmentsResponse, vs as zPostWebhookSubscriptions, yi as zPostWebhookSubscriptionsData, Li as zPostWebhookSubscriptionsResponse, wo as zPostalCode, Ja as zPutNotificationTemplateData, ta as zPutNotificationTemplateResponse, Ki as zPutNotificationTemplates, Fr as zPutShipmentData, Os as zPutShipmentResponse, tc as zPutShipments, ei as zQ, Ks as zRatesPostRatesRequestV1, _n as zRatesPostRatesRequestV2, T as zRatesResponsesRatesV1, Ls as zRefCapabilitiesContractDefinitionsResponseContractDefinitionsV1, En as zRefCapabilitiesContractDefinitionsResponseContractDefinitionsV2, U as zRefCapabilitiesContractDefinitionsResponseOptionsInsuranceOptionV1, P as zRefCapabilitiesContractDefinitionsResponseOptionsInsuranceOptionV2, Pt as zRefCapabilitiesContractDefinitionsResponseOptionsOptionV1, ka as zRefCapabilitiesContractDefinitionsResponseOptionsOptionV2, s as zRefCapabilitiesContractDefinitionsResponseOptionsOptionsV1, ba as zRefCapabilitiesContractDefinitionsResponseOptionsOptionsV2, gt as zRefCapabilitiesResponseCapabilityV1, Tt as zRefCapabilitiesResponseCapabilityV2, Ut as zRefCapabilitiesResponseCollo, se as zRefCapabilitiesResponseOptionsInsuranceOptionV1, Pe as zRefCapabilitiesResponseOptionsInsuranceOptionV2, st as zRefCapabilitiesResponseOptionsOptionV1, cn as zRefCapabilitiesResponseOptionsOptionV2, uc as zRefCapabilitiesResponseOptionsOptionsV1, g as zRefCapabilitiesResponseOptionsOptionsV2, Wn as zRefCapabilitiesResponsePhysicalPropertiesPhysicalPropertiesV1, Te as zRefCapabilitiesResponsePhysicalPropertiesPhysicalPropertiesV2, Fn as zRefCapabilitiesResponsePhysicalPropertiesPhysicalProperty, $n as zRefCapabilitiesSharedCarrier, ge as zRefCapabilitiesSharedCarrierV2, Qe as zRefCapabilitiesSharedContractV1, No as zRefCapabilitiesSharedContractV2, Ue as zRefCapabilitiesSharedOptionsBaseOptionV1, _r as zRefCapabilitiesSharedOptionsBaseOptionV2, cr as zRefCapabilitiesSharedOptionsBaseOptionsV1, Er as zRefCapabilitiesSharedOptionsBaseOptionsV2, Qt as zRefCapabilitiesSharedOptionsInsuranceBaseInsuranceV1, te as zRefCapabilitiesSharedOptionsInsuranceBaseInsuranceV2, Ti as zRefNotificationNotificationTemplateType, os as zRefNotificationResponseNotificationGroup, to as zRefNotificationResponseNotificationTemplate, Bo as zRefRatesResponseContract, ca as zRefRatesResponseContractV2, Hr as zRefRatesResponsePriceCompositionPriceCompositionV1, fo as zRefRatesResponsePriceCompositionPriceCompositionV2, Xo as zRefRatesResponsePriceCompositionPriceV1, si as zRefRatesResponsePriceCompositionPriceV2, Ia as zRefRatesResponseRateV1, gs as zRefRatesResponseRateV2, _i as zRefShipmentAddressV2, Fi as zRefShipmentBpostBpostPugoType, So as zRefShipmentCustomsDeclaration, Ka as zRefShipmentCustomsDeclarationItem, $i as zRefShipmentGeneralSettings, Wi as zRefShipmentLabelPrintingPosition, Nr as zRefShipmentLocationType, Es as zRefShipmentLocationTypeV2, $s as zRefShipmentLocationV2, Qr as zRefShipmentOptionsDeliveryTypeAll, Ws as zRefShipmentOptionsDeliveryTypeDeliveryDate, hn as zRefShipmentOptionsInsurance, C as zRefShipmentOptionsInsuranceMax, Fs as zRefShipmentOptionsLabelDescription, wn as zRefShipmentOptionsOptions, V as zRefShipmentOptionsOptionsReturns, M as zRefShipmentOptionsPackageTypeAll, Mt as zRefShipmentOptionsPackageTypeReturns, Da as zRefShipmentPackageType, a as zRefShipmentPackageType1Package, va as zRefShipmentPackageType2Mailbox, mt as zRefShipmentPackageType6SmallPackage, Ct as zRefShipmentPackageTypeV2, Vt as zRefShipmentPhysicalPropertiesPropertiesHeight, ae as zRefShipmentPhysicalPropertiesPropertiesLength, Me as zRefShipmentPhysicalPropertiesPropertiesVolume, at as zRefShipmentPhysicalPropertiesPropertiesWeight, on as zRefShipmentPhysicalPropertiesPropertiesWidth, cc as zRefShipmentPickup, m as zRefShipmentPickupV2, Hn as zRefShipmentRecipientSecondaryEmails, Ce as zRefShipmentReferenceIdentifier, Nn as zRefShipmentSender, Zn as zRefShipmentShipmentOptions, me as zRefShipmentShipmentOptionsReturns, Xe as zRefShipmentShipmentTypeV2, jo as zRefShipmentTransactionStatus, Ve as zRefShipmentType, hr as zRefTypesCarrier, or as zRefTypesCarrierReturns, wr as zRefTypesCc, Xt as zRefTypesDeliveryType, t as zRefTypesDeliveryTypeV2, Ai as zRefTypesIntBoolean, ds as zRefTypesMoney, oo as zRefTypesMoneyNullableAmount, Go as zRefTypesMoneyPropertiesAmount, pa as zRefTypesMoneyPropertiesCurrency, qr as zRefTypesPriceEuro, _o as zRefTypesShipmentType, ts as zRefTypesTransactionTypes, fi as zRefTypesValueWithUnit, Va as zRefWebhookWebhookV10, xs as zRefWebhookWebhookV11, xi as zReference, zi as zReferenceIdentifier, Eo as zRegion, Xa as zSendTestNotificationData, ra as zSendTestNotificationResponse, Ji as zShipmentDefsCarrierTrackTraceEvent, Lr as zShipmentDefsCarrierTrackTraceHistory, As as zShipmentDefsCustomsShipmentType, rc as zShipmentDefsDeliveryMomentPropertiesTimeFrame, ni as zShipmentDefsDeliveryMomentPropertiesType, Js as zShipmentDefsDeliveryOptionsDeliveryNameV2, yn as zShipmentDefsDeliveryOptionsDeliveryTimeFrame, D as zShipmentDefsDeliveryOptionsOpeningHours, zs as zShipmentDefsDeliveryOptionsOpeningHoursDefinitionsOpeningHours, On as zShipmentDefsDeliveryOptionsPickup, G as zShipmentDefsDeliveryOptionsPickupTime, I as zShipmentDefsExternalProviderPropertiesDisplayName, It as zShipmentDefsExternalProviderPropertiesId, ja as zShipmentDefsExternalTrackTraceLink, l as zShipmentDefsMainStatus, Sa as zShipmentDefsOccupancy, vt as zShipmentDefsShipment, Dt as zShipmentDefsShipmentCarrierPropertiesExternalIdentifier, Gt as zShipmentDefsShipmentDropOffPoint, le as zShipmentDefsShipmentOriginPropertiesOrigin, Ie as zShipmentDefsShipmentOriginPropertiesUserAgent, lt as zShipmentDefsShipmentPartnerTracktraces, un as zShipmentDefsShipmentPaymentStatus, fc as zShipmentDefsShipmentPhysicalProperties, v as zShipmentDefsShipmentPhysicalPropertiesPropertiesHeight, Kn as zShipmentDefsShipmentPhysicalPropertiesPropertiesLength, De as zShipmentDefsShipmentPhysicalPropertiesPropertiesVolume, Ln as zShipmentDefsShipmentPhysicalPropertiesPropertiesWeight, tr as zShipmentDefsShipmentPhysicalPropertiesPropertiesWidth, ve as zShipmentDefsShipmentPickup, et as zShipmentDefsShipmentPropertiesAccountId, Fo as zShipmentDefsShipmentPropertiesAmount, Ge as zShipmentDefsShipmentPropertiesBarcode, yr as zShipmentDefsShipmentPropertiesCarrierId, ur as zShipmentDefsShipmentPropertiesCollectionContact, Or as zShipmentDefsShipmentPropertiesContractId, en as zShipmentDefsShipmentPropertiesCreated, re as zShipmentDefsShipmentPropertiesCreatedBy, Mi as zShipmentDefsShipmentPropertiesCurrency, ps as zShipmentDefsShipmentPropertiesCustomsDeclaration, co as zShipmentDefsShipmentPropertiesDelayed, qo as zShipmentDefsShipmentPropertiesDelivered, ha as zShipmentDefsShipmentPropertiesDropOffPoint, Yr as zShipmentDefsShipmentPropertiesExternalIdentifier, yo as zShipmentDefsShipmentPropertiesExternalProvider, rs as zShipmentDefsShipmentPropertiesExternalProviderId, mi as zShipmentDefsShipmentPropertiesGeneralSettings, Ua as zShipmentDefsShipmentPropertiesHidden, Cs as zShipmentDefsShipmentPropertiesId, Ci as zShipmentDefsShipmentPropertiesLinkConsumerPortal, Vi as zShipmentDefsShipmentPropertiesModified, Oo as zShipmentDefsShipmentPropertiesModifiedBy, Qa as zShipmentDefsShipmentPropertiesMultiColloMainShipmentId, aa as zShipmentDefsShipmentPropertiesOptions, Xi as zShipmentDefsShipmentPropertiesOrderShipmentIdentifier, zr as zShipmentDefsShipmentPropertiesOrigin, Ms as zShipmentDefsShipmentPropertiesParentId, ac as zShipmentDefsShipmentPropertiesPartnerTracktraces, ii as zShipmentDefsShipmentPropertiesPaymentStatus, Xs as zShipmentDefsShipmentPropertiesPhysicalProperties, xn as zShipmentDefsShipmentPropertiesPickup, k as zShipmentDefsShipmentPropertiesPickupRequestNumber, Vs as zShipmentDefsShipmentPropertiesPlatformId, An as zShipmentDefsShipmentPropertiesPrice, q as zShipmentDefsShipmentPropertiesRecipient, R as zShipmentDefsShipmentPropertiesReferenceIdentifier, Rt as zShipmentDefsShipmentPropertiesRegion, Na as zShipmentDefsShipmentPropertiesSender, d as zShipmentDefsShipmentPropertiesShipmentType, wa as zShipmentDefsShipmentPropertiesShippedItems, bt as zShipmentDefsShipmentPropertiesShopId, kt as zShipmentDefsShipmentPropertiesStatus, qt as zShipmentDefsShipmentPropertiesTransactionStatus, de as zShipmentDefsShipmentPropertiesUserAgent, Re as zShipmentDefsShipmentRecipient, dt as zShipmentDefsShipmentSender, fn as zShipmentDefsShipmentSenderPropertiesEmail, mc as zShipmentDefsShipmentShippedItem, b as zShipmentDefsShipmentStatus, Jn as zShipmentDefsTrackTrace, ke as zShipmentDefsTrackTraceProofOfDelivery, zn as zShipmentDefsTrackingLocation, rr as zShipmentIds, be as zShipmentParametersBarcode, nt as zShipmentParametersCarrierId, Lo as zShipmentParametersCarrierIdentifier, qe as zShipmentParametersCarrierName, xr as zShipmentParametersCollectDate, fr as zShipmentParametersCutoffTime, Ar as zShipmentParametersDeliveryDate, nn as zShipmentParametersDeliveryOptionsIdentifier, n as zShipmentParametersDeliveryTime, Ei as zShipmentParametersDeliveryType, ss as zShipmentParametersDeliveryTypes, no as zShipmentParametersLabelPosition, Vo as zShipmentParametersPackageType, la as zShipmentParametersPaperSize, Ur as zShipmentParametersPostalCode, po as zShipmentParametersShipmentType, Zo as zShipmentParametersSortShipment, ci as zShipmentParametersStatus, La as zShipmentParametersTracktracesExtraInfo, _s as zShipmentPostReturnShipmentsRequest, vi as zShipmentPostShipmentsRequest, Ii as zShipmentPostShipmentsRequestV11, Co as zShipmentPostUnrelatedReturnShipmentsRequest, qa as zShipmentPutShipmentsRequest, ea as zShipmentPutShipmentsRequestV11, Gi as zShipmentResponsesBulkShipmentLabelsPaymentRequired, Pr as zShipmentResponsesDeliveryOptionsDeliveryOptionV1, Ds as zShipmentResponsesDeliveryOptionsDeliveryOptionV2, ec as zShipmentResponsesDeliveryOptionsDeliveryPossibility, $r as zShipmentResponsesDeliveryOptionsDeliveryTime, Gs as zShipmentResponsesDeliveryOptionsPackageTypeV2, gn as zShipmentResponsesDeliveryOptionsV1, w as zShipmentResponsesDeliveryOptionsV2, Is as zShipmentResponsesDownloadableLabel, Tn as zShipmentResponsesDropOffPoint, H as zShipmentResponsesDropOffPointDefinitionsAvailableDays, N as zShipmentResponsesDropOffPointDefinitionsOpeningHours, Nt as zShipmentResponsesDropOffPointDefinitionsTimeframe, Oa as zShipmentResponsesDropOffPointDefinitionsTimeframes, o as zShipmentResponsesDropOffPoints, ya as zShipmentResponsesPaymentInstructions, ht as zShipmentResponsesPickupLocations, wt as zShipmentResponsesPickupLocationsDefinitionsAddress, Ht as zShipmentResponsesPickupLocationsDefinitionsLocation, oe as zShipmentResponsesPickupLocationsDefinitionsOpeningHours, Ne as zShipmentResponsesPickupLocationsDefinitionsPickupLocation, ot as zShipmentResponsesPickupLocationsDefinitionsPossibilities, sn as zShipmentResponsesPickupLocationsDefinitionsTimeframe, lc as zShipmentResponsesPostShipmentsV12, h as zShipmentResponsesPutShipmentsV12, Un as zShipmentResponsesShipmentIds, we as zShipmentResponsesShipmentIdsPropertiesDataPropertiesIds, Pn as zShipmentResponsesShipmentLabels, Qn as zShipmentResponsesShipments, he as zShipmentResponsesTracktraces, Ze as zShipmentType, Mo as zShopId, He as zShopId2, gr as zSize, sr as zSortShipment, Tr as zSortTracktraces, Zt as zStatus, ee as zStreet, Oi as zTracktraceExternalIdentifier, ls as zTransactionStatus, io as zUserAgent, Uo as zWebhookSubscriptionIds, da as zWebhooksPostWebhookSubscriptionsRequestV10, Gr as zWebhooksPostWebhookSubscriptionsRequestV11, ho as zWebhooksResponsesPostWebhookSubscriptions, $o as zWebhooksResponsesWebhookSubscriptionsV10, ui as zWebhooksResponsesWebhookSubscriptionsV11, za as zWebhooksResponsesWebhookV10, ys as zWebhooksResponsesWebhookV11 };
